<template>

  <v-container>

    <v-overlay :value="loading">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="snackbars.errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericInfoSnackbar" color="primary">

      {{ snackbars.genericInfoText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericInfoSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.genericErrorSnackbar" color="error">

      {{ snackbars.genericErrorText }}

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.genericErrorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-snackbar v-model="snackbars.addedToCartSnackbar" color="primary">

      The registration has been added to the cart.&nbsp;&nbsp;<router-link to="/Cart" style="color: white">View Cart</router-link>

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="snackbars.addedToCartSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="dialogs.manualPaymentAddedDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Manual Payment Added</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p><v-icon>mdi-check-circle</v-icon> The manual payment has been successfully applied.</p>

          <div>Payment Date: {{ newManualPayment.date }}</div>

          <div>Payment Method: {{ newManualPayment.paymentMethod }}</div>

          <div>Amount: ${{ newManualPayment.amount }}</div>

          <div>Description: {{ newManualPayment.description }}</div>

          <hr class="mt-4" />

          <v-alert icon="mdi-information-outline">

            <strong>Important:</strong> Please forward the details of this manual payment (if applicable) to <a :href="'mailto:' + newManualPayment.email">{{ newManualPayment.email }}</a>.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="closeManualPaymentAdded">close</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.manualRefundAddedDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Manual Refund Added</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p><v-icon>mdi-check-circle</v-icon> The manual refund has been successfully applied.</p>

          <div>Refund Date: {{ newManualRefund.date }}</div>

          <div>Refund Method: {{ newManualRefund.paymentMethod }}</div>

          <div>Amount: ${{ newManualRefund.amount }}</div>

          <div>Description: {{ newManualRefund.description }}</div>

          <hr class="mt-4" />

          <v-alert icon="mdi-information-outline">

            <strong>Important:</strong> Please inform the parcel owner by email about this manual refund.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="closeManualRefundAdded">close</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.addManualPaymentDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Add Manual Payment</strong></v-card-title>

        <v-card-text class="mt-2">

          <p class="caption">(*) indicates a required field</p>

          <v-row>

            <v-col cols="3">

              <v-menu v-model="manualPaymentDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="newManualPayment.date" label="Date*" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="manualPaymentDatePicker = parseDate(manualPaymentDate)" v-on="on" outlined style="max-width: 175px" :error-messages="dateOfManualPaymentErrors"></v-text-field>

                </template>

                <v-date-picker v-model="manualPaymentDatePicker" no-title @input="manualPaymentDateMenu = false"></v-date-picker>

              </v-menu>

            </v-col>

            <v-col cols="5">

              <v-autocomplete label="Payment Method*" v-model="newManualPayment.paymentMethod" :items="['Credit Card', 'Cheque', 'Cash']" style="max-width: 400px" outlined :error-messages="paymentMethodOfManualPaymentErrors"></v-autocomplete>

            </v-col>

            <v-col cols="4">

              <v-text-field id="manualPaymentAmount" label="Amount" v-model="newManualPayment.amount" style="max-width: 200px" outlined readonly prefix="$"></v-text-field>

            </v-col>

          </v-row>

          <v-textarea label="Description*" v-model="newManualPayment.description" maxlength="250" style="max-width: 1000px" rows="4" class="mt-1" outlined :error-messages="descriptionOfManualPaymentErrors"></v-textarea>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelAddManualPayment">cancel</v-btn>

          <v-btn color="primary" @click="confirmAddNewManualPayment">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.addManualRefundDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Add Manual Refund</strong></v-card-title>

        <v-card-text class="mt-2">

          <p class="caption">(*) indicates a required field</p>

          <v-row>

            <v-col cols="3">

              <v-menu v-model="manualRefundDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="newManualRefund.date" label="Date*" hint="MM/DD/YYYY" maxlength="10" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="manualRefundDatePicker = parseDate(manualRefundDate)" v-on="on" outlined style="max-width: 175px" :error-messages="dateOfManualRefundErrors"></v-text-field>

                </template>

                <v-date-picker v-model="manualRefundDatePicker" no-title @input="manualRefundDateMenu = false"></v-date-picker>

              </v-menu>

            </v-col>

            <v-col cols="5">

              <v-autocomplete label="Payment Method*" v-model="newManualRefund.paymentMethod" :items="['Credit Card', 'Cheque']" style="max-width: 400px" outlined :error-messages="paymentMethodOfManualRefundErrors"></v-autocomplete>

            </v-col>

            <v-col cols="4">

              <v-text-field id="manualRefundAmount" label="Amount" v-model="newManualRefund.amount" style="max-width: 200px" outlined readonly prefix="$"></v-text-field>

            </v-col>

          </v-row>

          <v-textarea label="Description*" v-model="newManualRefund.description" maxlength="250" style="max-width: 1000px" rows="4" class="mt-1" outlined :error-messages="descriptionOfManualRefundErrors"></v-textarea>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelAddManualRefund">cancel</v-btn>

          <v-btn color="primary" @click="confirmAddNewManualRefund">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.addParcelDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Parcel of Land and Owner Details</strong></v-card-title>

        <v-card-text class="mt-2">

          <v-alert icon="mdi-information-outline">

            <p>Enter the details for the parcel of land.  This is a two part process:</p>

            <ol>

              <li>Add details for the parcel of land</li>

              <li>Add the contact details for all parcel owners</li>

            </ol>

          </v-alert>

          <p class="caption">(*) indicates a required field</p>

          <v-text-field label="Address/Location*" v-model="newParcel.address" style="max-width: 400px" :error-messages="parcelAddressErrors" maxlength="100" outlined class="mt-2" :disabled="!dialogs.canEditAddress"></v-text-field>

          <v-autocomplete label="Municipality*" v-model="newParcel.municipality" :items="lists.municipalities" style="max-width: 400px" :error-messages="parcelMunicipalityErrors" outlined :disabled="!dialogs.canEditMunicipality"></v-autocomplete>

          <v-text-field label="Postal Code" v-model="newParcel.postalCode" placeholder="eg. K1A 0B1" maxlength="7" style="max-width: 400px" outlined :error-messages="parcelPostalCodeErrors" :disabled="!dialogs.canEditPostalCode"></v-text-field>

          <v-textarea label="Other Location Details" v-model="newParcel.otherLocationDetails" maxlength="250" style="max-width: 1000px" rows="4" outlined :disabled="!dialogs.canEditOtherLocationDetails"></v-textarea>

          <v-text-field label="Parcel Identifier (PID)" v-model="newParcel.pid" placeholder="eg. 111-222-3333" style="max-width: 400px" maxlength="11" outlined :error-messages="parcelPIDErrors" append-icon="mdi-information-outline" @click:append="showPIDInformation" :disabled="!dialogs.canEditPID"></v-text-field>

          <hr class="mb-6" />

          <h3 style="color: black" class="mb-2">Parcel Owner(s)</h3>

          <v-btn color="primary" @click="addOwner" class="mt-2 mb-4"><v-icon left>mdi-plus-circle</v-icon>Add Parcel Owner</v-btn>

          <v-alert icon="mdi-information-outline" v-if="newParcel.owners.length == 0">

            At least one owner is required.

          </v-alert>

          <ul>

            <li v-for="(obj, index) in newParcel.owners" :key="index">

              <div><span><strong>{{ obj.firstName }} {{ obj.lastName }}</strong></span><span v-if="obj.company"> ({{obj.company}})</span><span v-if="obj.isPrimary"> - Primary Contact</span></div>

              <div v-if="obj.addressLine1 && obj.city && obj.province && obj.postalCode">{{ obj.addressLine1 }}<span v-if="obj.addressLine2">, {{ obj.addressLine2 }}</span>, {{ obj.city }}, {{ obj.province }}, {{ obj.postalCode }}<span v-if="obj.preferredMethodOfContact == 'Mail'"> (preferred method of contact)</span></div>

              <div v-if="obj.phone"><span>{{ obj.phone }}</span><span v-if="obj.preferredMethodOfContact == 'Phone'"> (preferred method of contact)</span></div>

              <div v-if="obj.email"><span>{{ obj.email }}</span><span v-if="obj.preferredMethodOfContact == 'Email'"> (preferred method of contact)</span></div>

              <br />

              <a href="#" @click="updateOwner(index)">View/Edit Owner Details</a> | <a href="#" @click="confirmRemoveOwner(index)">Remove</a>

              <br />

              <br />

            </li>

          </ul>

          <div style="color: darkred; font-size: smaller !important" v-show="$v.newParcel && $v.newParcel.$dirty && $v.newParcel.owners && !$v.newParcel.owners.validateCannotBeEmpty">You must add at least one owner.</div>

          <p class="mt-4"></p>

          <p>

            <v-checkbox v-model="newParcel.isCertified" label="I confirm that I own this parcel or I have the owner's consent to enter information on their behalf" :error-messages="parcelIsCertifiedErrors"></v-checkbox>

          </p>

          <hr class="mb-6" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" />

          <h3 style="color: black" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" class="mb-6">Notes</h3>

          <v-textarea label="Notes" v-model="newParcel.notes" maxlength="4000" style="max-width: 1000px" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" outlined hide-details></v-textarea>

          <div style="text-align: right;" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <span class="caption" v-if="newParcel.notesLastUpdatedBy">This note was last updated by {{ newParcel.notesLastUpdatedBy }} on {{ newParcel.notesDateUpdated }}.</span>

          </div>

          <div style="text-align: right;" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-btn color="primary" class="mt-4" @click="updateParcelNotes"><v-icon left>mdi-pencil</v-icon>Save Note</v-btn>

          </div>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelAddParcel">cancel</v-btn>

          <v-btn color="primary" @click="submitNewParcel">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.addOwnerDialog" persistent max-width="475" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>{{ dialogs.addOwnerDialogMode == 'add' ? 'Add Parcel Owner' : 'Parcel Owner Information' }}</strong></v-card-title>

        <v-card-text class="mt-2">

          <p class="caption">(*) indicates a required field</p>

          <v-text-field label="First Name*" v-model="newOwner.firstName" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerFirstNameErrors" :readonly="!newOwner.canEditFirstName"></v-text-field>

          <v-text-field label="Last Name*" v-model="newOwner.lastName" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerLastNameErrors" :readonly="!newOwner.canEditFirstName"></v-text-field>

          <v-text-field label="Company (if applicable)" v-model="newOwner.company" style="max-width: 400px" maxlength="100" outlined class="mt-2"></v-text-field>

          <p>You must provide at least one contact method (email, phone, or mailing address).</p>

          <p>Preferred Method of Contact</p>

          <v-radio-group v-model="newOwner.preferredMethodOfContact" row>

            <v-radio key="email" label="Email" value="Email"></v-radio>

            <v-radio key="phone" label="Phone" value="Phone"></v-radio>

            <v-radio key="mail" label="Mail" value="Mail"></v-radio>

          </v-radio-group>

          <div style="color: darkred; font-size: smaller !important; margin-bottom: 10px" class="mt-1" v-show="$v.newOwner && $v.newOwner.$dirty && $v.newOwner.preferredMethodOfContact && !$v.newOwner.preferredMethodOfContact.required">Preferred Method of Contact is required.</div>

          <v-text-field label="Email" v-model="newOwner.email" placeholder="eg. john.smith@email.com" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerEmailErrors"></v-text-field>

          <v-autocomplete label="Country Code" v-model="newOwner.countryCode" :items="lists.countryCodes" maxlength="12" outlined style="max-width: 150px; display: inline-block" item-text="text" item-value="value" :error-messages="ownerCountryCodeErrors" class="mt-2"></v-autocomplete> <v-text-field label="Phone" v-model="newOwner.phone" placeholder="eg. 604-123-4567" maxlength="12" outlined style="width: 246px; max-width: 246px; display: inline-block" :error-messages="ownerPhoneErrors" class="mt-2"></v-text-field>

          <v-checkbox v-model="newOwner.isPrimary" label="Is this owner the primary contact?"></v-checkbox>

          <h4 class="mt-2">Mailing Address</h4>

          <p class="mt-4">To use the lookup tool, start typing the street address below:</p>

          <v-autocomplete v-model="newOwner.addressLookup" hide-no-data label="Address Lookup (for B.C. addresses only)" placeholder="Start typing to Search" :items="newOwner.addresses" :loading="newOwner.isLoading" :search-input.sync="searchOwner" outlined style="max-width: 400px;" maxlength="100"></v-autocomplete>

          <p>Or manually enter all fields, below:</p>

          <v-text-field label="Address" v-model="newOwner.addressLine1" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerAddressLine1Errors"></v-text-field>

          <v-text-field label="Apt / Unit / Suite (if applicable)" v-model="newOwner.addressLine2" style="max-width: 400px" maxlength="100" outlined></v-text-field>

          <v-text-field label="City" v-model="newOwner.city" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerCityErrors"></v-text-field>

          <v-autocomplete label="Province" v-model="newOwner.province" :items="lists.provinces" style="max-width: 400px" maxlength="100" outlined :error-messages="ownerProvinceErrors"></v-autocomplete>

          <v-text-field label="Postal Code" v-model="newOwner.postalCode" placeholder="eg. K1A 0B1" style="max-width: 400px" maxlength="7" outlined :error-messages="ownerPostalCodeErrors"></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelAddOwner">cancel</v-btn>

          <v-btn color="primary" @click="submitNewOwner">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.addOperatorDialog" persistent max-width="475" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>{{ dialogs.addOperatorDialogMode == 'add' ? 'Add Operator' : 'Operator Information' }}</strong></v-card-title>

        <v-card-text class="mt-2">

          <v-alert icon="mdi-information-outline" v-if="dialogs.addOperatorDialogMode == 'add'">

            Are the owners also operators (a person conducting the open burn)?  If yes, <a href="#" @click="selectOwner">click here to select an operator</a>.

          </v-alert>

          <hr v-if="dialogs.addOperatorDialogMode == 'add'" class="mb-6" />

          <v-text-field label="First Name*" v-model="newOperator.firstName" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorFirstNameErrors"></v-text-field>

          <v-text-field label="Last Name*" v-model="newOperator.lastName" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorLastNameErrors"></v-text-field>

          <v-text-field label="Company (if applicable)" v-model="newOperator.company" style="max-width: 400px" maxlength="100" outlined class="mt-2"></v-text-field>

          <p>You must provide at least one contact method (email, phone, or mailing address).</p>

          <p>Preferred Method of Contact</p>

          <v-radio-group v-model="newOperator.preferredMethodOfContact" row>

            <v-radio key="email" label="Email" value="Email"></v-radio>

            <v-radio key="phone" label="Phone" value="Phone"></v-radio>

            <v-radio key="mail" label="Mail" value="Mail"></v-radio>

          </v-radio-group>

          <div style="color: darkred; font-size: smaller !important; margin-bottom: 10px" class="mt-1" v-show="$v.newOperator && $v.newOperator.$dirty && $v.newOperator.preferredMethodOfContact && !$v.newOperator.preferredMethodOfContact.required">Preferred Method of Contact is required.</div>

          <v-text-field label="Email" v-model="newOperator.email" placeholder="eg. john.smith@email.com" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorEmailErrors"></v-text-field>

          <v-autocomplete label="Country Code" v-model="newOperator.countryCode" :items="lists.countryCodes" maxlength="12" outlined style="max-width: 150px; display: inline-block" item-text="text" item-value="value" :error-messages="operatorCountryCodeErrors" class="mt-2"></v-autocomplete> <v-text-field label="Phone" v-model="newOperator.phone" placeholder="eg. 604-123-4567" maxlength="12" outlined style="width: 246px; max-width: 246px; display: inline-block" :error-messages="operatorPhoneErrors" class="mt-2"></v-text-field>

          <h4 class="mt-2">Mailing Address</h4>

          <p class="mt-4">To use the lookup tool, start typing the street address below:</p>

          <v-autocomplete v-model="newOperator.addressLookup" hide-no-data label="Address Lookup (for B.C. addresses only)" placeholder="Start typing to Search" :items="newOperator.addresses" :loading="newOperator.isLoading" :search-input.sync="searchOperator" outlined style="max-width: 400px;" maxlength="100"></v-autocomplete>

          <p>Or manually enter all fields, below:</p>

          <v-text-field label="Address" v-model="newOperator.addressLine1" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorAddressLine1Errors"></v-text-field>

          <v-text-field label="Apt / Unit / Suite (if applicable)" v-model="newOperator.addressLine2" style="max-width: 400px" maxlength="100" outlined></v-text-field>

          <v-text-field label="City" v-model="newOperator.city" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorCityErrors"></v-text-field>

          <v-autocomplete label="Province" v-model="newOperator.province" :items="lists.provinces" style="max-width: 400px" maxlength="100" outlined :error-messages="operatorProvinceErrors"></v-autocomplete>

          <v-text-field label="Postal Code" v-model="newOperator.postalCode" placeholder="eg. K1A 0B1" style="max-width: 400px" maxlength="7" outlined :error-messages="operatorPostalCodeErrors"></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelAddOperator">cancel</v-btn>

          <v-btn color="primary" @click="submitNewOperator">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmAddManualPaymentDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to add a manual payment?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <div>Payment Date: {{ newManualPayment.date }}</div>

          <div>Payment Method: {{ newManualPayment.paymentMethod }}</div>

          <div>Amount: {{ newManualPayment.amount[0] === '-' ? '-$' + newManualPayment.amount.slice(1) : '$' + newManualPayment.amount }}</div>

          <div>Description: {{ newManualPayment.description }}</div>

          <hr class="mt-4" />

          <v-alert icon="mdi-information-outline" v-if="newParcel.owners.length == 0">

            <strong>Important:</strong> If you continue, the parcel's registration may be affected.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="cancelConfirmAddManualPayment" color="primary"><v-icon left>mdi-arrow-left-circle</v-icon>go back</v-btn> <v-btn color="primary" @click="submitNewManualPayment">confirm</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmAddManualRefundDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Confirm Manual Refund</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to add the manual refund?</p>

          <div>Refund Date: {{ newManualRefund.date }}</div>

          <div>Refund Method: {{ newManualRefund.paymentMethod }}</div>

          <div>Amount: {{ newManualRefund.amount[0] === '-' ? '-$' + newManualRefund.amount.slice(1) : '$' + newManualRefund.amount }}</div>

          <div>Description: {{ newManualRefund.description }}</div>

          <hr class="mt-4" />

          <v-alert icon="mdi-information-outline" v-if="newParcel.owners.length == 0">

            <strong>Important:</strong> If you continue, the parcel's registration may be affected.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="cancelConfirmAddManualRefund" color="primary"><v-icon left>mdi-arrow-left-circle</v-icon>go back</v-btn> <v-btn color="primary" @click="submitNewManualRefund">confirm</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>


    <v-dialog v-model="dialogs.confirmChargeInitialFeeDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break">Confirm Initial Fee?</v-card-title>

        <v-card-text class="text-body-1">

          <p>If you continue with this action, you will be charged the initial fee upon renewal.  Do you wish to continue?</p>

          <p>Warning: If you click on 'Yes', the action cannot be undone.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="confirmChargeInitialFee" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmChargeInitialFeeDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmRemoveParcelDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove Parcel of Land?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to remove the parcel address and owner(s)?</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="removeParcel" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmRemoveParcelDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmRemoveOwnerDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove Owner</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to remove the owner?</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="removeOwner" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmRemoveOwnerDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmRemoveRegistrationDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove Registration Details?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to remove the type of burn, dates, and operators?</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="removeRegistration" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmRemoveRegistrationDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelRegistrationDialog" persistent max-width="500">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel this registration?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-alert icon="mdi-information-outline">

            Your credit card will be refunded and you will not be authorized to conduct an open burn.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="cancelRegistration" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelRegistrationDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelRegistrationFromManualPaymentDialog" persistent max-width="500">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel this registration?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <v-alert icon="mdi-information-outline">

            <strong>Important:</strong> By clicking on 'Yes', a refund request will be sent to the administration staff and you will notified by email once it has been processed.  Additionally, the parcel's registration status will be updated immediately and you will not be authorized to conduct an open burn.

          </v-alert>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="cancelRegistration" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelRegistrationFromManualPaymentDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmRemoveOperatorDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove Operator</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Are you sure you want to remove the operator?</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="removeOperator" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmRemoveOperatorDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelNewOwnerDialog" persistent max-width="450">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Any unsaved data will be lost.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="confirmCancelNewOwner" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelNewOwnerDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelNewOperatorDialog" persistent max-width="450">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Any unsaved data will be lost.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="confirmCancelNewOperator" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelNewOperatorDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelNewParcelDialog" persistent max-width="450">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Any unsaved data will be lost.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="confirmCancelNewParcel" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelNewParcelDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.confirmCancelRegisterParcelDialog" persistent max-width="450">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Are you sure you want to cancel?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Any unsaved data will be lost.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="confirmCancelRegisterParcel" color="primary">yes</v-btn> <v-btn @click="dialogs.confirmCancelRegisterParcelDialog = false" color="primary">no</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.promptRegisterParcelDialog" persistent max-width="650">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Register Now?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p><v-icon>mdi-check-circle</v-icon> The parcel of land and owner details have been added.</p>

          <hr class="mb-4" />

          <p class="text-center">Continue registration for this parcel (select type of burn and add operator(s))?</p>

          <div class="mb-4" style="text-align: center"><v-btn @click="confirmPromptRegisterParcel" color="primary">yes, continue registration now</v-btn></div>

          <div style="text-align: center"><a href="#" @click="dialogs.promptRegisterParcelDialog = false">No, return to dashboard</a></div>

        </v-card-text>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.promptAddToCartDialog" persistent max-width="500">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Add to Cart?</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p><v-icon>mdi-check-circle</v-icon> The type of burn, start date and operator details have been added.</p>

          <hr class="mb-4" />

          <p class="text-center">Your registration is almost complete.  Add to cart and proceed to payment?</p>

          <div class="mb-4" style="text-align: center"><v-btn @click="confirmPromptAddToCart" color="primary">yes, add to cart now</v-btn></div>

          <div style="text-align: center"><a href="#" @click="dialogs.promptAddToCartDialog = false">No, return to dashboard</a></div>

        </v-card-text>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.promptAddParcelDialog" persistent max-width="600">

      <v-card>

        <v-card-title class="text-h5 mb-2 word-break"><strong>Welcome to the Open Burning Registration System!</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>To register a parcel of land:</p>

          <ol>

            <li>Add the parcel of land (address where the open burn will occur) and the parcel owner(s)</li>

            <li>Select the type of burn and start date for the 12-month period and add operator(s) (people conducting the burn)</li>

            <li>Pay the initial registration or renewal fee</li>

          </ol>

          <hr class="mt-6 mb-6" />

          <p class="text-center">Would you like to add a parcel of land now?</p>

          <div class="mt-4 mb-4" style="text-align: center"><v-btn color="primary" @click="confirmPromptAddParcel">yes, i will add a parcel of land now</v-btn></div>

          <div style="text-align: center"><a href="#" @click="dialogs.promptAddParcelDialog = false">No, I will add the parcel later</a></div>

        </v-card-text>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.registerParcelDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Burn and Operator Details<span style="color: gray" v-if="newRegistration.info != ''">&nbsp;- {{ newRegistration.info }}</span></strong></v-card-title>

        <v-card-text class="mt-2">

          <v-alert icon="mdi-information-outline">

            <p>Enter the details for the 12 months of registration.  This is a two part process:</p>

            <ol>

              <li>Select the type of burn and start date</li>

              <li>Add the contact details for operator(s) (the persons conducting open burning)</li>

            </ol>

          </v-alert>

          <hr class="mb-4" />

          <p class="caption">(*) indicates a required field</p>

          <p><strong>Type of Burn*:</strong></p>

          <v-radio-group v-model="newRegistration.typeOfBurn" row :disabled="!dialogs.canEditTypeOfBurnOnRegisterParcelDialog">

            <v-radio label="Agricultural" value="Agricultural"></v-radio>

            <v-radio label="Commercial" value="Commercial"></v-radio>

            <v-radio label="Residential" value="Residential"></v-radio>

            <v-radio label="Wildfire Risk Management" value="Wildfire Risk Management"></v-radio><v-icon small @click="showWildfireRiskManagementInformation">mdi-information-outline</v-icon>

            <div style="color: darkred; font-size: smaller !important" class="mt-1" v-show="$v.newRegistration && $v.newRegistration.$dirty && $v.newRegistration.typeOfBurn && !$v.newRegistration.typeOfBurn.required">Type of Burn is required.</div>

          </v-radio-group>

          <p style="text-align: center"><strong>12 Months of Registration</strong></p>

          <div style="display: flex; flex-wrap: wrap; margin-bottom: 15px">

            <div style="width: 50%; padding: 20px; border-style: solid; border-width: thin; border-color: lightgray; min-width: 350px">

              <p>Start Date*:</p>

              <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">

                <template v-slot:activator="{ on, attrs }">

                  <v-text-field v-model="newRegistration.startDate" label="Date" hint="MM/DD/YYYY" maxlength="10" :error-messages="registrationStartDateErrors" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" @blur="date = parseDate(newRegistration.startDate)" v-on="on" outlined style="max-width: 175px" :disabled="!dialogs.canEditTypeOfBurnOnRegisterParcelDialog"></v-text-field>

                </template>

                <v-date-picker v-model="date" no-title @input="startDateMenu = false"></v-date-picker>

              </v-menu>

            </div>

            <div style="width: 50%; padding: 20px; border-style: solid; border-width: thin; border-color: lightgray; min-width: 350px">

              <p>End Date:</p>

              <v-text-field id="endDate" v-model="newRegistration.endDate" label="Date" hint="MM/DD/YYYY" persistent-hint outlined style="max-width: 175px" readonly :disabled="!dialogs.canEditStartDateOnRegisterParcelDialog"></v-text-field>

              <small style="display: flex; align-items: baseline;">

                <v-icon color="gray" size="18" style="margin-top: 2px;">mdi-information-outline</v-icon>

                <span style="margin-left: 5px;">The end date is automatically calculated.</span>

              </small>

            </div>

          </div>

          <hr class="mb-6" />

          <h3 style="color: black" class="mb-2">Operator(s)</h3>

          <v-btn color="primary" @click="addOperator('registerParcel')" class="mt-2 mb-4"><v-icon left>mdi-plus-circle</v-icon>Add Operator</v-btn>

          <v-alert icon="mdi-information-outline" v-if="newRegistration.operators.length == 0">

            At least one operator is required (may be one of the owners).

          </v-alert>

          <ul>

            <li v-for="(obj, index) in newRegistration.operators" :key="index">

              <div><span><strong>{{ obj.firstName }} {{ obj.lastName }}</strong></span><span v-if="obj.company"> ({{obj.company}})</span></div>

              <div v-if="obj.addressLine1 && obj.city && obj.province && obj.postalCode">{{ obj.addressLine1 }}<span v-if="obj.addressLine2">, {{ obj.addressLine2 }}</span>, {{ obj.city }}, {{ obj.province }}, {{ obj.postalCode }}<span v-if="obj.preferredMethodOfContact == 'Mail'"> (preferred method of contact)</span></div>

              <div v-if="obj.phone"><span>{{ obj.phone }}</span><span v-if="obj.preferredMethodOfContact == 'Phone'"> (preferred method of contact)</span></div>

              <div v-if="obj.email"><span>{{ obj.email }}</span><span v-if="obj.preferredMethodOfContact == 'Email'"> (preferred method of contact)</span></div>

              <br />

              <a href="#" @click="updateOperator(index)">View/Edit Operator Details</a> | <a href="#" @click="confirmRemoveOperator(index)">Remove</a>

              <br />

              <br />

            </li>

          </ul>

          <div style="color: darkred; font-size: smaller !important" v-show="$v.newRegistration && $v.newRegistration.$dirty && $v.newRegistration.operators && !$v.newRegistration.operators.validateCannotBeEmpty">You must add at least one operator.</div>

          <hr class="mb-6" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" />

          <h3 style="color: black" class="mb-6" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">Notes</h3>

          <v-textarea label="Notes" v-model="newRegistration.notes" maxlength="4000" style="max-width: 1000px" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" outlined hide-details></v-textarea>

          <div v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" style="text-align: right;">

            <span class="caption" v-if="newRegistration.notesLastUpdatedBy">This note was last updated by {{ newRegistration.notesLastUpdatedBy }} on {{ newRegistration.notesDateUpdated }}.</span>

          </div>

          <div style="text-align: right;" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-btn color="primary" class="mt-4" @click="updateRegistrationNotes"><v-icon left>mdi-pencil</v-icon>Save Note</v-btn>

          </div>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="cancelRegisterParcel">cancel</v-btn>

          <v-btn color="primary" @click="submitNewRegistration">save</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.registrationHistoryDialog" persistent max-width="800" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Registration History</strong>&nbsp;<span style="color:gray">-&nbsp;{{ parcelInfo }}</span></v-card-title>

        <v-card-text class="mt-2">

          <ul>

            <li v-for="(obj, index) in registrationHistory" :key="index">

              <div>Registration Number: {{ obj.referenceNumber }}</div>

              <div>Registration Period: <strong>{{ obj.startDate }}</strong> to <strong>{{ obj.endDate }}</strong></div>

              <div>Type of Burn: {{ obj.typeOfBurn }}</div>

              <div>Registration Paid? {{ obj.registrationPaid }}</div>

              <br />

              <div><a href="#" @click="openRegistrationDetails(obj.id)">View Details</a></div>

              <hr v-if="index != registrationHistory.length - 1" class="mb-6 mt-6" />

            </li>

          </ul>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="dialogs.registrationHistoryDialog = false">close</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.registrationDetailsDialog" persistent max-width="800" scrollable>

      <v-card v-if="registrationDetails">

        <v-card-title class="text-h5 word-break"><strong>Registration Details</strong></v-card-title>

        <v-card-text class="mt-2">

          <div><strong>Registration Number:</strong> {{ registrationDetails.registrationReferenceNumber }}</div>

          <div><strong>Registration Period:</strong> {{ registrationDetails.startDate }} to {{ registrationDetails.endDate }}</div>

          <hr class="mb-6 mt-6" />

          <h3 style="color: black" class="mb-4">Burn Type and Fee</h3>

          <div><strong>Type of Burn:</strong> {{ registrationDetails.typeOfBurn }}</div>

          <div><strong>Fee:</strong> {{ registrationDetails.fee }}</div>

          <div><strong>Fee Type:</strong> {{ registrationDetails.feeType }}</div>

          <div><strong>Payment Status:</strong> {{ registrationDetails.paymentStatus }}</div>

          <hr class="mb-6 mt-6" />

          <h3 style="color: black" class="mb-4">Operator(s)</h3>

          <ul>

            <li v-for="(obj, index) in registrationDetails.operators" :key="index">

              <div><span>{{ obj.firstName }} {{ obj.lastName }}</span><span v-if="obj.company"> ({{obj.company}})</span></div>

              <div v-if="obj.addressLine1 && obj.city && obj.province && obj.postalCode">{{ obj.addressLine1 }}<span v-if="obj.addressLine2">, {{ obj.addressLine2 }}</span>, {{ obj.city }}, {{ obj.province }}, {{ obj.postalCode }}<span v-if="obj.preferredMethodOfContact == 'Mail'"> (preferred method of contact)</span></div>

              <div v-if="obj.phone"><span>{{ obj.phone }}</span><span v-if="obj.preferredMethodOfContact == 'Phone'"> (preferred method of contact)</span></div>

              <div v-if="obj.email"><span>{{ obj.email }}</span><span v-if="obj.preferredMethodOfContact == 'Email'"> (preferred method of contact)</span></div>

            </li>

          </ul>

          <div class="mt-4 ml-6" v-if="!registrationDetails.registrationOccursInThePast"><a href="#" @click="addOrEditOperators">Add/Edit Operator Details</a></div>

          <span v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

                    <hr class="mb-6 mt-6" />

                    <h3 style="color: black" class="mb-4">Parcel Information</h3>

                    <div><strong>MV Number:</strong> {{ registrationDetails.parcelReferenceNumber }}</div>

                    <div><strong>Parcel Address:</strong> {{ registrationDetails.parcelAddress }}</div>

                    <div><strong>Municipality:</strong> {{ registrationDetails.municipality }}</div>

                    <div v-if="registrationDetails.postalCode"><strong>Postal Code:</strong> {{ registrationDetails.postalCode }}</div>

                    <div v-if="registrationDetails.pid"><strong>PID:</strong> {{ registrationDetails.pid }}</div>

                    <div v-if="registrationDetails.otherLocationDetails"><strong>Other Location Details:</strong> {{ registrationDetails.otherLocationDetails }}</div>

                    <v-alert icon="mdi-information-outline">

                      <strong>Important:</strong> This information was recorded at time of purchase and may have changed.

                    </v-alert>

                    <hr class="mb-6 mt-6" />

                    <h3 style="color: black" class="mb-4">Owner(s)</h3>

                    <ul>

                        <li v-for="(obj, index) in registrationDetails.owners" :key="index">

                            <div><span>{{ obj.firstName }} {{ obj.lastName }}</span><span v-if="obj.company"> ({{obj.company}})</span><span v-if="obj.isPrimary"> - Primary Contact</span></div>

                            <div v-if="obj.addressLine1 && obj.city && obj.province && obj.postalCode">{{ obj.addressLine1 }}<span v-if="obj.addressLine2">, {{ obj.addressLine2 }}</span>, {{ obj.city }}, {{ obj.province }}, {{ obj.postalCode }}<span v-if="obj.preferredMethodOfContact == 'Mail'"> (preferred method of contact)</span></div>

                            <div v-if="obj.phone"><span>{{ obj.phone }}</span><span v-if="obj.preferredMethodOfContact == 'Phone'"> (preferred method of contact)</span></div>

                            <div v-if="obj.email"><span>{{ obj.email }}</span><span v-if="obj.preferredMethodOfContact == 'Email'"> (preferred method of contact)</span></div>

                        </li>

                    </ul>

                    <v-alert icon="mdi-information-outline">

                      <strong>Important:</strong> This information was recorded at time of purchase and may have changed.

                    </v-alert>

                  </span>

          <hr class="mb-6 mt-6" />

          <h3 style="color: black" class="mb-4">Order Information</h3>

          <div class="mt-4 mb-4"><u>Payment</u></div>

          <div v-if="registrationDetails.orderNumberForPayment"><strong>Order Number:</strong> {{ registrationDetails.orderNumberForPayment }}</div>

          <div v-if="registrationDetails.cardHolderForPayment"><strong>Card Holder:</strong> {{ registrationDetails.cardHolderForPayment }}</div>

          <div v-if="registrationDetails.expiryForPayment"><strong>Expiry:</strong> {{ registrationDetails.expiryForPayment }}</div>

          <div v-if="registrationDetails.first6Last4ForPayment"><strong>Card Number:</strong> {{ registrationDetails.first6Last4ForPayment ? registrationDetails.first6Last4ForPayment.slice(0,6) : '' }}******{{ registrationDetails.first6Last4ForPayment ? registrationDetails.first6Last4ForPayment.slice(-4) : '' }}</div>

          <div v-if="registrationDetails.cardTypeForPayment"><strong>Card Type:</strong> {{ registrationDetails.cardTypeForPayment }}</div>

          <div v-if="registrationDetails.transactionDateForPayment"><strong>Transaction Date:</strong> {{ registrationDetails.transactionDateForPayment }}</div>

          <div v-if="registrationDetails.transactionTotalForPayment"><strong>Transaction Total:</strong> {{ registrationDetails.transactionTotalForPayment }}</div>

          <div v-if="registrationDetails.transactionNumberForPayment"><strong>Transaction Number:</strong> {{ registrationDetails.transactionNumberForPayment }}</div>

          <div v-if="($store.state.user.role == 'Admin' || $store.state.user.role == 'Officer') && registrationDetails.descriptionForPayment"><strong>Description:</strong> {{ registrationDetails.descriptionForPayment }}</div>

          <div v-if="registrationDetails.transactionTotalForRefund" class="mt-4 mb-4"><u>Refund</u></div>

          <div v-if="registrationDetails.orderNumberForRefund"><strong>Order Number:</strong> {{ registrationDetails.orderNumberForRefund }}</div>

          <div v-if="registrationDetails.cardHolderForRefund"><strong>Card Holder:</strong> {{ registrationDetails.cardHolderForRefund }}</div>

          <div v-if="registrationDetails.expiryForRefund"><strong>Expiry:</strong> {{ registrationDetails.expiryForRefund }}</div>

          <div v-if="registrationDetails.first6Last4ForRefund"><strong>Card Number:</strong> {{ registrationDetails.first6Last4ForRefund ? registrationDetails.first6Last4ForRefund.slice(0,6) : '' }}******{{ registrationDetails.first6Last4ForRefund ? registrationDetails.first6Last4ForRefund.slice(-4) : '' }}</div>

          <div v-if="registrationDetails.cardTypeForRefund"><strong>Card Type:</strong> {{ registrationDetails.cardTypeForRefund }}</div>

          <div v-if="registrationDetails.transactionDateForRefund"><strong>Transaction Date:</strong> {{ registrationDetails.transactionDateForRefund }}</div>

          <div v-if="registrationDetails.transactionTotalForRefund"><strong>Transaction Total:</strong> {{ registrationDetails.transactionTotalForRefund }}</div>

          <div v-if="registrationDetails.transactionNumberForRefund"><strong>Transaction Number:</strong> {{ registrationDetails.transactionNumberForRefund }}</div>

          <div v-if="($store.state.user.role == 'Admin' || $store.state.user.role == 'Officer') && registrationDetails.descriptionForRefund"><strong>Description:</strong> {{ registrationDetails.descriptionForRefund }}</div>

          <hr class="mt-6 mb-6" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" />

          <h3 style="color: black" class="mb-6" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">Notes</h3>

          <v-textarea label="Notes" v-model="registrationDetails.notes" maxlength="4000" style="max-width: 1000px" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" outlined hide-details></v-textarea>

          <div v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" style="text-align: right;">

            <span class="caption" v-if="registrationDetails.notesLastUpdatedBy">This note was last updated by {{ registrationDetails.notesLastUpdatedBy }} on {{ registrationDetails.notesDateUpdated }}.</span>

          </div>

          <div style="text-align: right;" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'">

            <v-btn color="primary" class="mt-4" @click="updateRegistrationDetailsNotes"><v-icon left>mdi-pencil</v-icon>Save Note</v-btn>

          </div>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="submitRegistrationDetails">close</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.importOwnerDetailsDialog" persistent max-width="475" scrollable>

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Select an Operator</strong></v-card-title>

        <v-card-text class="mt-2">

          <v-alert icon="mdi-information-outline">

            <strong>Important:</strong>&nbsp;&nbsp;You will need to repeat this process for each owner that is an operator.

          </v-alert>

          <hr />

          <p class="mt-4">Please select an operator from the list of owners below:</p>

          <ul>

            <li v-for="(obj, index) in newParcel.owners" :key="index">

              <div><span><strong>{{ obj.firstName }} {{ obj.lastName }}</strong></span><span v-if="obj.company"> ({{obj.company}})</span><span v-if="obj.isPrimary"> - Primary Contact</span></div>

              <div v-if="obj.addressLine1 && obj.city && obj.province && obj.postalCode">{{ obj.addressLine1 }}<span v-if="obj.addressLine2">, {{ obj.addressLine2 }}</span>, {{ obj.city }}, {{ obj.province }}, {{ obj.postalCode }}<span v-if="obj.preferredMethodOfContact == 'Mail'"> (preferred method of contact)</span></div>

              <div v-if="obj.phone"><span>{{ obj.phone }}</span><span v-if="obj.preferredMethodOfContact == 'Phone'"> (preferred method of contact)</span></div>

              <div v-if="obj.email"><span>{{ obj.email }}</span><span v-if="obj.preferredMethodOfContact == 'Email'"> (preferred method of contact)</span></div>

              <br />

              <a href="#" @click="importOwnerDetails(index)">Select</a>

              <br />

              <br />

            </li>

          </ul>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" @click="dialogs.importOwnerDetailsDialog = false">cancel</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.pidInformationDialog" persistent max-width="500">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Parcel Identifier (PID)</strong></v-card-title>

        <v-card-text class="text-body-1">

          You can find the PID on your property tax notice or by searching <a href="https://www.bcassessment.ca" target="_blank">https://www.bcassessment.ca</a>.

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="dialogs.pidInformationDialog = false" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.wildfireRiskManagementInformationDialog" persistent max-width="500">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Wildfire Risk Management</strong></v-card-title>

        <v-card-text class="text-body-1">

          See Part 8 of <a href='https://metrovancouver.org/boards/Bylaws/MVRD_Bylaw_1355.pdf#page=9' target="_blank">Bylaw 1355</a>.

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="dialogs.wildfireRiskManagementInformationDialog = false" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="dialogs.parcelRemovedDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Remove Parcel</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>The parcel has been removed.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="navigateToDashboard" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout class="mb-2">

      <v-spacer></v-spacer>

      You are signed in as&nbsp;<strong>{{ $store.state.user.email }}</strong>&nbsp;<span v-if="$store.state.user.role != 'User'">({{ $store.state.user.role == 'Admin' ? 'Administrator' : $store.state.user.role }})</span>

    </v-layout>

    <v-card elevation="0">

      <v-card-title class="text-h5 ml-2 mr-2" v-if="$route.query.id == null"><strong>Dashboard</strong></v-card-title>

      <v-card-text>

        <v-layout class="ml-2 mr-4 mb-10" v-if="$route.query.id == null">

          <v-row>

            <v-btn color="primary" class="mt-6 ml-3" @click="addParcel"><v-icon left>mdi-plus-circle</v-icon>add parcel of land</v-btn>

            <v-spacer></v-spacer>

            <v-text-field v-if="false" outlined placeholder="Search Parcels..." append-icon="mdi-magnify" style="max-width: 400px"></v-text-field>

          </v-row>

        </v-layout>

        <v-alert icon="mdi-information-outline" v-if="$route.query.id == null">

          <p>To register a parcel of land for open burning:</p>

          <ol>

            <li>Add the parcel of land (address where the open burn will occur) and the parcel owner(s)</li>

            <li>Select the type of burn and start date for the 12-month period and add operator(s) (people conducting the burn)</li>

            <li>Pay the initial registration or renewal fee</li>

          </ol>

        </v-alert>

        <div style="padding: 10px; margin-bottom: 20px; background: whitesmoke" class="text-center" v-if="$store.state.user.role == 'Admin' || $store.state.user.role == 'Officer'" v-html="formInfo"></div>

        <hr class="mb-6" v-if="$route.query.id == null" />

        <p class="ml-2" v-if="parcels.length == 0">There are no parcels entered yet.</p>

        <ul class="mb-4">

          <li v-for="(obj, index) in parcels" :key="index">

            <div class="mb-4"><h3>{{ obj.address }}, {{ obj.municipality }}<span v-if="obj.postalCode != null && obj.postalCode != ''">, {{ obj.postalCode }}</span><span v-if="obj.otherLocationDetails != null && obj.otherLocationDetails != ''"> - {{ obj.otherLocationDetails != null ? (obj.otherLocationDetails.length > 50 ? obj.otherLocationDetails.substr(0, 50) + '...' : obj.otherLocationDetails) : '' }}</span></h3></div>

            <div>MV Number: {{ obj.referenceNumber }}</div>

            <div>Parcel Registration Status: <v-icon v-if="obj.status === 'Registered'" color="green">mdi-check-circle</v-icon> <strong>{{ obj.status }}</strong></div>

            <br />

            <div>

              <a href="#" @click="updateParcel(obj.id)">View/Edit Parcel and Owner Details</a>

              <span v-if="obj.canAddRegistration"> | <a href="#" @click="registerParcel(obj.id)">Add Burn and Operator Details</a></span>

              <span v-if="obj.hasRegistrationHistory"> | <a href="#" @click="openRegistrationHistory(obj.id)">Registration History</a></span>

              <span v-if="obj.canRemoveParcel"> | <a href="#" @click="confirmRemoveParcel(obj.id)">Remove</a></span>

            </div>

            <br />

            <div style="display: flex; flex-wrap: wrap;">

              <div style="width: 50%; padding: 20px; border-style: solid; border-width: thin; border-color: lightgray; min-width: 350px" v-if="obj.registrations.length >= 1">

                <div>Registration Number: {{ obj.registrations[0].referenceNumber }}</div>

                <div>Registration Period: <strong>{{ obj.registrations[0].startDate }}</strong> to <strong>{{ obj.registrations[0].endDate }}</strong></div>

                <div>Type of Burn: {{ obj.registrations[0].typeOfBurn }}</div>

                <div>Registration Paid? {{ obj.registrations[0].registrationPaid }}</div>

                <br />

                <div>

                  <a href="#" @click="updateRegistration(obj.registrations[0].id, false)" v-if="obj.registrations[0].canEditRegistration">View/Edit Details</a>

                  <a href="#" @click="openRegistrationDetails(obj.registrations[0].id)" v-if="!obj.registrations[0].canEditRegistration">View Details</a>

                  <span v-if="obj.registrations[0].showAddToCart && $store.state.user.role == 'User'">&nbsp;| <a href="#" @click="addToCart(obj.registrations[0].id)">Add to Cart</a></span>

                  <span v-if="obj.registrations[0].canAddManualPayment && $store.state.user.role == 'Admin'">&nbsp;| <a href="#" @click="addManualPayment(obj.registrations[0].id)">Add Manual Payment</a></span>

                  <span v-if="obj.registrations[0].canAddManualRefund && $store.state.user.role == 'Admin'">&nbsp;| <a href="#" @click="addManualRefund(obj.registrations[0].id)">Add Manual Refund</a></span>

                  <span v-if="obj.registrations[0].canCancelRegistration">&nbsp;| <a href="#" @click="confirmCancelRegistration(obj.registrations[0].id)">Cancel Registration</a></span>

                  <span v-if="obj.registrations[0].canRemoveRegistration"> | <a href="#" @click="confirmRemoveRegistration(obj.registrations[0].id)">Remove</a></span>

                  <div v-if="obj.registrations[0].addedToCart" class="mt-2">

                    <v-icon small class="mr-2">mdi-cart</v-icon>

                    <span class="caption">You have added this registration to your cart.</span>

                  </div>

                  <div v-if="obj.registrations[0].refundInfoHTML" class="mt-2">

                    <v-icon small class="mr-2">mdi-check-circle-outline</v-icon>

                    <span class="caption" v-html="obj.registrations[0].refundInfoHTML"></span>

                  </div>

                </div>

              </div>

              <div style="width: 50%; padding: 20px; border-style: solid; border-width: thin; border-color: lightgray; min-width: 350px" v-if="obj.registrations.length == 2">

                <div>Registration Number: {{ obj.registrations[1].referenceNumber }}</div>

                <div>Registration Period: <strong>{{ obj.registrations[1].startDate }}</strong> to <strong>{{ obj.registrations[1].endDate }}</strong></div>

                <div>Type of Burn: {{ obj.registrations[1].typeOfBurn }}</div>

                <div>Registration Paid? {{ obj.registrations[1].registrationPaid }}</div>

                <br />

                <div>

                  <a href="#" @click="updateRegistration(obj.registrations[1].id, false)" v-if="obj.registrations[1].canEditRegistration">View/Edit Details</a>

                  <a href="#" @click="openRegistrationDetails(obj.registrations[1].id)" v-if="!obj.registrations[1].canEditRegistration">View Details</a>

                  <span v-if="obj.registrations[1].showAddToCart && $store.state.user.role == 'User'">&nbsp;| <a href="#" @click="addToCart(obj.registrations[1].id)">Add to Cart</a></span>

                  <span v-if="obj.registrations[1].canAddManualPayment && $store.state.user.role == 'Admin'">&nbsp;| <a href="#" @click="addManualPayment(obj.registrations[1].id)">Add Manual Payment</a></span>

                  <span v-if="obj.registrations[1].canAddManualRefund && $store.state.user.role == 'Admin'">&nbsp;| <a href="#" @click="addManualRefund(obj.registrations[1].id)">Add Manual Refund</a></span>

                  <span v-if="obj.registrations[1].canCancelRegistration">&nbsp;| <a href="#" @click="confirmCancelRegistration(obj.registrations[1].id)">Cancel Registration</a></span>

                  <span v-if="obj.registrations[1].canRemoveRegistration"> | <a href="#" @click="confirmRemoveRegistration(obj.registrations[1].id)">Remove</a></span>

                  <div v-if="obj.registrations[1].addedToCart" class="mt-2">

                    <v-icon small class="mr-2">mdi-cart</v-icon>

                    <span class="caption">You have added this registration to your cart.</span>

                  </div>

                  <div v-if="obj.registrations[1].refundInfoHTML" class="mt-2">

                    <v-icon small class="mr-2">mdi-check-circle-outline</v-icon>

                    <span class="caption" v-html="obj.registrations[1].refundInfoHTML"></span>

                  </div>

                </div>

              </div>

            </div>

            <hr v-if="index != parcels.length - 1" class="mb-6 mt-6" />

          </li>

        </ul>

      </v-card-text>

    </v-card>

  </v-container>

</template>

<script lang="ts">

import Vue from 'vue'

import axios from "axios";

import {required} from "vuelidate/lib/validators";

function validateDateFormat(value:string) {

  if (value == '') return true;

  const regex = /^\d{2}\/\d{2}\/\d{4}$/;

  return regex.test(value);
}

function validateDateIsWithin6Months(value:any, data:any) {

  // determine if we need to validate the start date
  if (data.validateStartDate) {

    // yes, we need to validate the start date

    var availableDates = data.availableStartDates;

    var result = availableDates.includes(value);

    return result;

  }
  else {

    // no, we don't need to validate the start date (in the case the registration screen is greyed out)

    return true;

  }

}
function formatDate(date:any) {

  const year = date.getFullYear();

  const month = (date.getMonth() + 1).toString().padStart(2, '0');

  const day = date.getDate().toString().padStart(2, '0');

  return `${month}/${day}/${year}`;

}

interface Owner {

  id: number | null,

  firstName: string;

  lastName: string;

  company: string;

  email: string;

  isPrimary: boolean;

  addressLine1: string;

  addressLine2: string;

  city: string;

  postalCode: string;

  province: string;

  preferredMethodOfContact: string;

  countryCode: string;

  phone: string;

  canEditFirstName: boolean;

  canEditLastName: boolean;
}

interface Operator {

  firstName: string;

  lastName: string;

  company: string;

  email: string;

  addressLine1: string;

  addressLine2: string;

  city: string;

  postalCode: string;

  province: string;

  preferredMethodOfContact: string;

  phone: string;

  countryCode: string;
}

function validateEmailFormat(value: string | null) {

  var isValid = true;

  if (value) {

    var query = value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (query == null) isValid = false;

  }

  return isValid;

}

function validateMustBeYes(value: any, data: any) {

  if (value == 'Yes') return true;

  return false;
}


function validateMustBeTrue(value: any, data: any) {

  if (value) {

    return true;

  }

  return false;
}

function validateCannotBeEmpty(value: any, data: any) {

  if (value) {

    if (value.length > 0)
    {
      return true;
    }

  }

  return false;
}

function validateEmailIsRequired(value: any, data: any) {

  // if the preferred method of contact is email, then the email is required

  var isValid = true;

  // is the preferred method of contact email?
  if (data.preferredMethodOfContact == 'Email') {

    // yes, the preferred method of contact is email

    // is the email blank?
    if (data.email == '')
    {
      // yes, the email is blank

      isValid = false;
    }
  }

  return isValid;
}

function validatePhoneIsRequired(value: any, data: any) {

  // if the preferred method of contact is phone, then the phone is required

  var isValid = true;

  // is the preferred method of contact phone?
  if (data.preferredMethodOfContact == 'Phone') {

    // yes, the preferred method of contact is phone

    // is the phone blank?
    if (!data.phone)
    {
      // yes, the phone is blank

      isValid = false;
    }
  }

  return isValid;
}

function validateAddressLine1IsRequired(value: any, data: any) {

  // if the preferred method of contact is mail, then address line 1 is required

  var isValid = true;

  // is the preferred method of contact mail?
  if (data.preferredMethodOfContact == 'Mail') {

    // yes, the preferred method of contact is mail

    // is the address line 1 blank?
    if (!data.addressLine1)
    {
      // yes, the address line 1 is blank

      isValid = false;
    }
  }

  return isValid;

}

function validateCityIsRequired(value: any, data: any) {

  // if the preferred method of contact is mail, then city is required

  var isValid = true;

  // is the preferred method of contact email?
  if (data.preferredMethodOfContact == 'Mail') {

    // yes, the preferred method of contact is mail

    // is the city blank?
    if (!data.city)
    {
      // yes, the city is blank

      isValid = false;
    }
  }

  return isValid;

}

function validateProvinceIsRequired(value: any, data: any) {

  // if the preferred method of contact is mail, then province is required

  var isValid = true;

  // is the preferred method of contact mail?
  if (data.preferredMethodOfContact == 'Mail') {

    // yes, the preferred method of contact is mail

    // is the province blank?
    if (!data.province)
    {
      // yes, the province is blank

      isValid = false;
    }
  }

  return isValid;

}

function validatePostalCodeIsRequired(value: any, data: any) {

  // if the preferred method of contact is mail, then postal code is required

  var isValid = true;

  // is the preferred method of contact mail?
  if (data.preferredMethodOfContact == 'Mail') {

    // yes, the preferred method of contact is mail

    // is the postal code blank?
    if (!data.postalCode)
    {
      // yes, the postal code is blank

      isValid = false;
    }
  }

  return isValid;

}

function validatePostalCodeFormat(value: string | null) {

  var isValid = true;

  if (value && value != '') {

    var query1 = value.match(/^[a-z][0-9][a-z] [0-9][a-z][0-9]$/gmi);

    var query2 = value.match(/^[a-z][0-9][a-z][0-9][a-z][0-9]$/gmi);

    if (query1 == null && query2 == null) isValid = false;

  }

  return isValid;

}

function validatePhoneFormat(value: string | null) {

  if (value == '') return true;

  var isValid = true;

  if (value) {

    var query1 = value.match(/^\d{3}-\d{3}-\d{4}$/gmi);

    if (query1 == null) isValid = false;

  }

  return isValid;

}

function validatePIDFormat(value: string | null) {

  if (value == '') return true;

  var isValid = true;

  if (value) {

    var query1 = value.match(/^\d{3}-\d{3}-\d{3}$/gmi);

    var query2 = value.match(/^\d{9}$/gm);

    if (query1 == null && query2 == null) isValid = false;

  }

  return isValid;

}

export default Vue.extend({

  name: 'Success',

  validations: {

    newManualPayment: {

      date: {

        required

      },

      paymentMethod: {

        required

      },

      description: {

        required

      }

    },

    newManualRefund: {

      date: {

        required

      },

      paymentMethod: {

        required

      },

      description: {

        required

      }

    },

    newParcel: {

      address: {

        required

      },

      municipality: {

        required

      },

      PID: {

        validatePIDFormat

      },

      postalCode: {

        validatePostalCodeFormat

      },

      owners: {

        validateCannotBeEmpty

      },

      isCertified: {

        validateMustBeTrue

      }

    },

    newOwner: {

      firstName: {

        required

      },

      lastName: {

        required

      },

      email: {

        validateEmailIsRequired,

        validateEmailFormat

      },

      countryCode: {

        required

      },

      phone: {

        validatePhoneIsRequired,

        validatePhoneFormat

      },

      addressLine1: {

        validateAddressLine1IsRequired

      },

      city: {

        validateCityIsRequired

      },

      province: {

        validateProvinceIsRequired

      },

      postalCode: {

        validatePostalCodeIsRequired,

        validatePostalCodeFormat

      },

      preferredMethodOfContact: {

        required

      }

    },

    newRegistration: {

      typeOfBurn: {

        required

      },

      startDate: {

        required,

        validateDateFormat,

        validateDateIsWithin6Months

      },

      operators: {

        validateCannotBeEmpty

      }

    },

    newOperator: {

      firstName: {

        required

      },

      lastName: {

        required

      },

      email: {

        validateEmailIsRequired,

        validateEmailFormat

      },

      countryCode: {

        required

      },

      phone: {

        validatePhoneIsRequired,

        validatePhoneFormat

      },

      addressLine1: {

        validateAddressLine1IsRequired

      },

      city: {

        validateCityIsRequired

      },

      province: {

        validateProvinceIsRequired

      },

      postalCode: {

        validatePostalCodeIsRequired,

        validatePostalCodeFormat

      },

      preferredMethodOfContact: {

        required

      }

    }

  },

  computed: {

    dateOfManualPaymentErrors()
    {
      if (!this.$v.newManualPayment.$dirty) return [];

      if (this.$v.newManualPayment.date && !this.$v.newManualPayment.date.required)
      {
        return ['Date is required.'];
      }

      return [];

    },

    paymentMethodOfManualPaymentErrors()
    {
      if (!this.$v.newManualPayment.$dirty) return [];

      if (this.$v.newManualPayment.paymentMethod && !this.$v.newManualPayment.paymentMethod.required)
      {
        return ['Payment Method is required.'];
      }

      return [];

    },

    paymentMethodOfManualRefundErrors()
    {
      if (!this.$v.newManualRefund.$dirty) return [];

      if (this.$v.newManualRefund.paymentMethod && !this.$v.newManualRefund.paymentMethod.required)
      {
        return ['Payment Method is required.'];
      }

      return [];

    },

    descriptionOfManualPaymentErrors()
    {
      if (!this.$v.newManualPayment.$dirty) return [];

      if (this.$v.newManualPayment.description && !this.$v.newManualPayment.description.required)
      {
        return ['Description is required.'];
      }

      return [];

    },

    dateOfManualRefundErrors()
    {
      if (!this.$v.newManualRefund.$dirty) return [];

      if (this.$v.newManualRefund.date && !this.$v.newManualRefund.date.required)
      {
        return ['Date is required.'];
      }

      return [];

    },

    descriptionOfManualRefundErrors()
    {
      if (!this.$v.newManualRefund.$dirty) return [];

      if (this.$v.newManualRefund.description && !this.$v.newManualRefund.description.required)
      {
        return ['Description is required.'];
      }

      return [];

    },

    parcelAddressErrors()
    {
      if (!this.$v.newParcel.$dirty) return [];

      if (this.$v.newParcel.address && !this.$v.newParcel.address.required)
      {
        return ['Address is required.'];
      }

      return [];

    },

    parcelMunicipalityErrors()
    {
      if (!this.$v.newParcel.$dirty) return [];

      if (this.$v.newParcel.municipality && !this.$v.newParcel.municipality.required)
      {
        return ['Municipality is required.'];
      }

      return [];

    },

    parcelPIDErrors() {

      if (!this.$v.newParcel.$dirty) return [];

      if (this.$v.newParcel.pid && !this.$v.newParcel.pid.validatePIDFormat) {

        return ['PID is invalid.'];

      }

      return [];

    },

    parcelIsCertifiedErrors() {

      if (!this.$v.newParcel.$dirty) return [];

      if (this.$v.newParcel.isCertified && !this.$v.newParcel.isCertified.validateMustBeTrue) {

        return ['You must click the box above to continue.'];

      }

      return [];

    },

    parcelPostalCodeErrors()
    {
      if (!this.$v.newParcel.$dirty) return [];

      if (this.$v.newParcel.postalCode && !this.$v.newParcel.postalCode.validatePostalCodeFormat)
      {
        return ['Postal Code is invalid.'];
      }

      return [];
    },

    registrationStartDateErrors()
    {
      if (!this.$v.newRegistration.$dirty) return [];

      if (this.$v.newRegistration && this.$v.newRegistration.startDate  && !this.$v.newRegistration.startDate.required)
      {
        return ['Start Date is required.'];
      }
      else if (this.$v.newRegistration && this.$v.newRegistration.startDate && !this.$v.newRegistration.startDate.validateDateFormat)
      {
        return ['Start Date is invalid.'];
      }
      else if (this.$v.newRegistration && this.$v.newRegistration.startDate && !this.$v.newRegistration.startDate.validateDateIsWithin6Months)
      {
        return ['Start Date must be between today and 6 months from now.'];
      }

      return [];
    },

    ownerFirstNameErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.firstName && this.$v.newOwner && !this.$v.newOwner.firstName.required)
      {
        return ['First Name is required.'];
      }

      return [];
    },

    ownerLastNameErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.lastName && !this.$v.newOwner.lastName.required)
      {
        return ['Last Name is required.'];
      }

      return [];
    },

    ownerEmailErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.email && !this.$v.newOwner.email.validateEmailIsRequired)
      {
        return ['Email is required.'];
      }

      if (this.$v.newOwner.email && !this.$v.newOwner.email.validateEmailFormat)
      {
        return ['Email is invalid.'];
      }

      return [];
    },

    ownerCountryCodeErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.countryCode && !this.$v.newOwner.countryCode.required)
      {
        return ['Country Code is required.'];
      }

      return [];
    },

    ownerPhoneErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.phone && !this.$v.newOwner.phone.validatePhoneIsRequired)
      {
        return ['Phone is required.'];
      }

      if (this.$v.newOwner.phone && !this.$v.newOwner.phone.validatePhoneFormat)
      {
        return ['Phone is invalid.'];
      }

      return [];
    },

    ownerAddressLine1Errors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.addressLine1 && !this.$v.newOwner.addressLine1.validateAddressLine1IsRequired)
      {
        return ['Address is required.'];
      }

      return [];
    },

    ownerCityErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.city && !this.$v.newOwner.city.validateCityIsRequired)
      {
        return ['City is required.'];
      }

      return [];
    },

    ownerProvinceErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.province && !this.$v.newOwner.province.validateProvinceIsRequired)
      {
        return ['Province is required.'];
      }

      return [];
    },

    ownerPostalCodeErrors()
    {
      if (!this.$v.newOwner.$dirty) return [];

      if (this.$v.newOwner.postalCode && !this.$v.newOwner.postalCode.validatePostalCodeIsRequired)
      {
        return ['Postal Code is required.'];
      }

      if (this.$v.newOwner.postalCode && !this.$v.newOwner.postalCode.validatePostalCodeFormat)
      {
        return ['Postal Code is invalid.'];
      }

      return [];
    },

    operatorFirstNameErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.firstName && this.$v.newOperator && !this.$v.newOperator.firstName.required)
      {
        return ['First Name is required.'];
      }

      return [];
    },

    operatorLastNameErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.lastName && !this.$v.newOperator.lastName.required)
      {
        return ['Last Name is required.'];
      }

      return [];
    },

    operatorEmailErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.email && !this.$v.newOperator.email.validateEmailIsRequired)
      {
        return ['Email is required.'];
      }

      if (this.$v.newOperator.email && !this.$v.newOperator.email.validateEmailFormat)
      {
        return ['Email is invalid.'];
      }

      return [];
    },

    operatorCountryCodeErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.countryCode && !this.$v.newOperator.countryCode.required)
      {
        return ['Country Code is required.'];
      }

      return [];
    },

    operatorPhoneErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.phone && !this.$v.newOperator.phone.validatePhoneIsRequired)
      {
        return ['Phone is required.'];
      }

      if (this.$v.newOperator.phone && !this.$v.newOperator.phone.validatePhoneFormat)
      {
        return ['Phone is invalid.'];
      }

      return [];
    },

    operatorAddressLine1Errors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.addressLine1 && !this.$v.newOperator.addressLine1.validateAddressLine1IsRequired)
      {
        return ['Address is required.'];
      }

      return [];
    },

    operatorCityErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.city && !this.$v.newOperator.city.validateCityIsRequired)
      {
        return ['City is required.'];
      }

      return [];
    },

    operatorProvinceErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.province && !this.$v.newOperator.province.validateProvinceIsRequired)
      {
        return ['Province is required.'];
      }

      return [];
    },

    operatorPostalCodeErrors()
    {
      if (!this.$v.newOperator.$dirty) return [];

      if (this.$v.newOperator.postalCode && !this.$v.newOperator.postalCode.validatePostalCodeIsRequired)
      {
        return ['Postal Code is required.'];
      }

      if (this.$v.newOperator.postalCode && !this.$v.newOperator.postalCode.validatePostalCodeFormat)
      {
        return ['Postal Code is invalid.'];
      }

      return [];
    }

  },

  async created() {

    this.loading = true;

    setTimeout(async () => {

      try {

        let obj = await axios.get('accounts/get-user-info');

        var tokens = obj.data.split('\t');

        var email = tokens[1];

        var role = tokens[2];

        this.$store.dispatch('updateEmail', email);

        this.$store.dispatch('updateRole', role);

        // if the user is an admin (or officer) and there is no parcel id in the query string, then we need to redirect them to the Admin Dashboard

        if ((role == 'Admin' || role == 'Officer') && !this.$route.query.id) {

          // the role is admin (or officer) and there is no parcel id in the querystring

          if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

        }

        let countryCodes = await axios.get('api/CountryCode/GetCountryCodes');

        this.lists.countryCodes = countryCodes.data;

        let provinces = await axios.get('api/Province/GetProvinces');

        this.lists.provinces = provinces.data;

        let municipalities = await axios.get('api/Parcel/GetMunicipalities');

        this.lists.municipalities = municipalities.data;

        let query = await axios.get('api/Registration/GetAvailableStartDates');

        this.availableStartDates = query.data;

        if (this.$route.query.id) {

          let query = { data: null as any };

          this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

          this.loading = false;

          this.parcels = query.data;

        } else {

          let query = await axios.get('api/Parcel/GetParcelsForDashboard');

          this.loading = false;

          this.parcels = query.data;

          if (this.parcels.length == 0) {

            this.dialogs.promptAddParcelDialog = true;

          }

        }
      }
      catch
      {
        if (this.$route.path != '/Login') this.$router.push('/Login');
      }

    }, 200);

  },

  data () {

    return {

      newManualPayment: {

        registrationId: null as number | null,

        date: '',

        paymentMethod: '',

        amount: '',

        description: '',

        email: ''
      },

      newManualRefund: {

        registrationId: null as number | null,

        date: '',

        paymentMethod: '',

        amount: '',

        description: ''

      },

      manualPaymentDateMenu: false,

      manualPaymentDatePicker: '',

      manualPaymentDate: '',

      manualRefundDateMenu: false,

      manualRefundDatePicker: '',

      manualRefundDate: '',

      parcelInfo: '',

      formInfo: '',

      availableStartDates: [],

      registrationHistory: [],

      registrationDetails: null as any,

      parcelId: null as number | null,

      registrationId: null as number | null,

      date: '',

      startDateMenu: false,

      loading: false,

      removeOwnerIndex: null as number | null,

      removeOperatorIndex: null as number | null,

      updateOwnerIndex: null as number | null,

      updateOperatorIndex: null as number | null,

      dialogs: {

        manualPaymentAddedDialog: false,

        manualRefundAddedDialog: false,

        addManualPaymentDialog: false,

        addManualRefundDialog: false,

        addParcelDialog: false,

        canEditAddress: true,

        canEditMunicipality: true,

        canEditPostalCode: true,

        canEditOtherLocationDetails: true,

        canEditPID: true,

        addParcelDialogMode: 'add',

        canEditIsCertifiedOnAddParcelDialog: true,

        addOwnerDialog: false,

        addOwnerDialogMode: 'add',

        registerParcelDialog: false,

        canEditStartDateOnRegisterParcelDialog: true,

        canEditTypeOfBurnOnRegisterParcelDialog: true,

        registrationHistoryDialog: false,

        registrationDetailsDialog: false,

        importOwnerDetailsDialog: false,

        registerParcelDialogMode: 'add',

        addOperatorDialog: false,

        addOperatorDialogMode: 'add',

        confirmChargeInitialFeeDialog: false,

        confirmRemoveParcelDialog: false,

        confirmAddManualPaymentDialog: false,

        confirmAddManualRefundDialog: false,

        confirmRemoveOwnerDialog: false,

        confirmRemoveRegistrationDialog: false,

        confirmCancelRegistrationDialog: false,

        confirmCancelRegistrationFromManualPaymentDialog: false,

        confirmRemoveOperatorDialog: false,

        confirmCancelNewOwnerDialog: false,

        confirmCancelNewOperatorDialog: false,

        confirmCancelNewParcelDialog: false,

        confirmCancelRegisterParcelDialog: false,

        promptRegisterParcelDialog: false,

        promptAddToCartDialog: false,

        promptAddParcelDialog: false,

        confirmRegisterParcelId: null as number | null,

        pidInformationDialog: false,

        wildfireRiskManagementInformationDialog: false,

        parcelRemovedDialog: false

      },

      snackbars: {

        errorSnackbar: false,

        genericErrorSnackbar: false,

        genericErrorText: '',

        genericInfoSnackbar: false,

        genericInfoText: '',

        addedToCartSnackbar: false

      },

      lists: {

        provinces: [] as string[],

        municipalities: [] as string[],

        countryCodes: []

      },

      searchOwner: null,

      searchOperator: null,

      parcels: [],

      newParcel: {

        id: null as number | null,

        address: '',

        municipality: '',

        postalCode: '',

        otherLocationDetails: '',

        pid: '',

        owners: [] as Owner[],

        isCertified: false,

        notes: '',

        notesLastUpdatedBy: '',

        notesDateUpdated: '',

        hasPayment: false

      },

      newOwner: {

        company: '',

        firstName: '',

        lastName: '',

        email: '',

        countryCode: '1CA',

        phone: '',

        addressLine1: '',

        addressLine2: '',

        city: '',

        province: '',

        postalCode: '',

        preferredMethodOfContact: '',

        isPrimary: false,

        addressLookup: '',

        addresses: [] as string[],

        isLoading: false,

        entries: [] as string[],

        canEditFirstName: true,

        canEditLastName: true

      },

      newOperator: {

        company: '',

        firstName: '',

        lastName: '',

        email: '',

        countryCode: '1CA',

        phone: '',

        addressLine1: '',

        addressLine2: '',

        city: '',

        province: '',

        postalCode: '',

        preferredMethodOfContact: '',

        addressLookup: '',

        addresses: [] as string[],

        isLoading: false,

        entries: [] as string[]

      },

      newRegistration: {

        id: null as number | null,

        parcelId: null as number | null,

        typeOfBurn: '',

        startDate: '',

        endDate: '',

        operators: [] as Operator[],

        availableStartDates: [],

        info: '',

        validateStartDate: true,

        notes: '',

        notesDateUpdated: '',

        notesLastUpdatedBy: ''
      }

    }

  },

  methods: {

    closeManualPaymentAdded() {

      this.dialogs.manualPaymentAddedDialog = false;

      this.loading = true;

      setTimeout(async () => {

        try {

          let query = { data: null as any };

          this.loading = false;

          this.parcels = query.data;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    },

    closeManualRefundAdded() {

      this.dialogs.manualRefundAddedDialog = false;

      this.loading = true;

      setTimeout(async () => {

        try {

          let query = { data: null as any };

          this.loading = false;

          this.parcels = query.data;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    },

    cancelConfirmAddManualPayment() {

      this.clearSnackbars();

      this.dialogs.confirmAddManualPaymentDialog = false;

      this.dialogs.addManualPaymentDialog = true;

    },

    cancelConfirmAddManualRefund() {

      this.clearSnackbars();

      this.dialogs.confirmAddManualRefundDialog = false;

      this.dialogs.addManualRefundDialog = true;

    },

    confirmAddNewManualPayment() {

      this.clearSnackbars();

      this.$v.newManualPayment.$touch();

      if (this.$v.newManualPayment.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        // the form is valid

        this.dialogs.addManualPaymentDialog = false;

        this.dialogs.confirmAddManualPaymentDialog = true;

      }

    },


    confirmAddNewManualRefund() {

      this.clearSnackbars();

      this.$v.newManualRefund.$touch();

      if (this.$v.newManualRefund.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        // the form is valid

        this.dialogs.addManualRefundDialog = false;

        this.dialogs.confirmAddManualRefundDialog = true;

      }

    },

    submitNewManualPayment() {

      this.dialogs.confirmAddManualPaymentDialog = false;

      this.loading = true;

      setTimeout(async () => {

        this.newManualPayment.registrationId = this.registrationId;

        let obj = { data: null as any };

        this.loading = false;

        if (obj.data == '%%PAYMENT_NOT_ALLOWED%%' || obj.data == '%%REFUND_NOT_ALLOWED%%')
        {
          this.dialogs.confirmAddManualPaymentDialog = true;

          this.snackbars.genericErrorText = 'The manual payment could not be applied to the registration.';

          this.snackbars.genericErrorSnackbar = true;
        }
        else if (obj.data.indexOf('%%SUCCESS%%') > -1)
        {
          this.newManualPayment.email = obj.data.replace('%%SUCCESS%%-', '');

          this.dialogs.manualPaymentAddedDialog = true;
        }
        else
        {
          this.snackbars.genericErrorText = 'There was an issue creating the manual payment.  Please contact Metro Vancouver for further assistance.';

          this.snackbars.genericErrorSnackbar = true;
        }

      }, 200);

    },

    submitNewManualRefund() {

      this.dialogs.confirmAddManualRefundDialog = false;

      this.loading = true;

      setTimeout(async () => {

        this.newManualRefund.registrationId = this.registrationId;

        let obj = { data: null as any };

        this.loading = false;

        if (obj.data == '%%PAYMENT_NOT_ALLOWED%%' || obj.data == '%%REFUND_NOT_ALLOWED%%')
        {
          this.dialogs.confirmAddManualRefundDialog = true;

          this.snackbars.genericErrorText = 'The manual payment could not be applied to the registration.';

          this.snackbars.genericErrorSnackbar = true;
        }
        else
        {
          this.dialogs.manualRefundAddedDialog = true;
        }

      }, 200);

    },

    cancelAddManualPayment() {

      this.clearSnackbars();

      this.dialogs.addManualPaymentDialog = false;

    },

    cancelAddManualRefund() {

      this.clearSnackbars();

      this.dialogs.addManualRefundDialog = false;

    },

    addManualPayment(registrationId:any) {

      this.clearSnackbars();

      this.registrationId = registrationId;

      this.$v.newManualPayment.$reset();

      this.newManualPayment.date = '';

      this.newManualPayment.paymentMethod = '';

      this.newManualPayment.amount = '';

      this.newManualPayment.description = '';

      this.loading = true;

      setTimeout(async () => {

        try {

          let obj = await axios.get('api/Registration/GetRegistration?id=' + this.registrationId);

          this.loading = false;

          this.newManualPayment.amount = obj.data.fee.replace('$', '');

          this.dialogs.addManualPaymentDialog = true;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    },

    addManualRefund(registrationId:any) {

      this.clearSnackbars();

      this.registrationId = registrationId;

      this.$v.newManualRefund.$reset();

      this.newManualRefund.date = '';

      this.newManualRefund.paymentMethod = '';

      this.newManualRefund.amount = '';

      this.newManualRefund.description = '';

      this.loading = true;

      setTimeout(async () => {

        try {

          let obj = await axios.get('api/Registration/GetRegistration?id=' + this.registrationId);

          this.loading = false;

          const feeWithoutDollarSign = obj.data.fee.replace('$', '');

          const negatedAmount = (-parseFloat(feeWithoutDollarSign)).toFixed(2);

          this.newManualRefund.amount = negatedAmount;

          this.dialogs.addManualRefundDialog = true;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    },

    addOrEditOperators() {

      this.dialogs.registrationDetailsDialog = false;

      this.updateRegistration(this.registrationId, true);

    },

    navigateToDashboard() {

      if (this.$route.path != '/Dashboard') this.$router.push('/Dashboard');

    },

    updateParcelNotes() {

      this.clearSnackbars();

      setTimeout(async () => {

        var vm = {

          id: this.parcelId,

          notes: this.newParcel.notes

        }

        let obj = { data: null as any };

        this.newParcel.notesDateUpdated = obj.data.notesDateUpdated;

        this.newParcel.notesLastUpdatedBy = obj.data.notesLastUpdatedBy;

        this.snackbars.genericInfoText = 'The notes have been updated.';

        this.snackbars.genericInfoSnackbar = true;

      }, 200);

    },

    updateRegistrationNotes() {

      this.clearSnackbars();

      setTimeout(async () => {

        var vm = {

          id: this.registrationId,

          notes: this.newRegistration.notes

        }

        let obj = { data: null as any };

        this.newRegistration.notesDateUpdated = obj.data.notesDateUpdated;

        this.newRegistration.notesLastUpdatedBy = obj.data.notesLastUpdatedBy;

        this.snackbars.genericInfoText = 'The notes have been updated.';

        this.snackbars.genericInfoSnackbar = true;

      }, 200);

    },

    updateRegistrationDetailsNotes() {

      this.clearSnackbars();

      setTimeout(async () => {

        var vm = {

          id: this.registrationId,

          notes: this.registrationDetails.notes

        }

        let obj = { data: null as any };

        this.registrationDetails.notesDateUpdated = obj.data.notesDateUpdated;

        this.registrationDetails.notesLastUpdatedBy = obj.data.notesLastUpdatedBy;

        this.snackbars.genericInfoText = 'The notes have been updated.';

        this.snackbars.genericInfoSnackbar = true;

      }, 200);

    },

    showWildfireRiskManagementInformation() {

      this.clearSnackbars();

      this.dialogs.wildfireRiskManagementInformationDialog = true;

    },

    showPIDInformation() {

      this.clearSnackbars();

      this.dialogs.pidInformationDialog = true;

    },

    async confirmChargeInitialFee() {

      this.clearSnackbars();

      this.dialogs.confirmChargeInitialFeeDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Parcel/SetIsChargeInitialFee?id=' + this.parcelId);

        this.loading = false;

      }, 200);

      this.$v.newOwner.$reset();

      this.newOwner.company = '';

      this.newOwner.firstName = '';

      this.newOwner.lastName = '';

      this.newOwner.email = '';

      this.newOwner.countryCode = '1CA';

      this.newOwner.phone = '';

      this.newOwner.addressLine1 = '';

      this.newOwner.addressLine2 = '';

      this.newOwner.city = '';

      this.newOwner.province = '';

      this.newOwner.postalCode = '';

      this.newOwner.preferredMethodOfContact = '';

      this.newOwner.isPrimary = false;

      this.updateOwnerIndex = null;

      this.dialogs.addOwnerDialogMode = 'add';

      this.dialogs.addOwnerDialog = true;

    },

    async submitRegistrationDetails() {

      this.clearSnackbars();

      this.dialogs.registrationDetailsDialog = false;

      var obj = {

        registrationId: this.registrationId,

        operators: this.registrationDetails.operators

      }

      this.loading = true;

      setTimeout(async () => {

        let obj1 = await axios.post('api/Registration/UpdateOperators', obj);

        this.loading = false;

      }, 200);

    },

    confirmRemoveRegistration(id:any) {

      this.clearSnackbars();

      this.registrationId = id;

      this.dialogs.confirmRemoveRegistrationDialog = true;

    },

    confirmCancelRegistration(id:any) {

      this.clearSnackbars();

      this.loading = true;

      this.registrationId = id;

      setTimeout(async () => {

        try {

          let obj = await axios.get('api/Order/GetIsLastPaymentManual?registrationId=' + id);

          if (obj.data == '%%NO%%'){

            this.dialogs.confirmCancelRegistrationDialog = true;

          }
          else
          {
            this.dialogs.confirmCancelRegistrationFromManualPaymentDialog = true;
          }

          this.loading = false;

        } catch (error) {

          if (this.$route.path != '/Login') this.$router.push('/Login');

        }

      }, 200)

    },

    cancelRegistration(id:any) {

      this.clearSnackbars();

      this.dialogs.confirmCancelRegistrationDialog = false;

      this.dialogs.confirmCancelRegistrationFromManualPaymentDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Checkout/CancelRegistration?id=' + this.registrationId);

        if (obj.data == '%%SUCCESS%%')
        {
          if (this.$route.query.id) {

            let query = { data: null as any };

            this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

            this.parcels = query.data;

          } else {

            let query = await axios.get('api/Parcel/GetParcelsForDashboard');

            this.parcels = query.data;

          }

          this.loading = false;

          this.snackbars.genericInfoText = 'The registration has been successfully cancelled.';

          this.snackbars.genericInfoSnackbar = true;
        }
        else if (obj.data == '%%REQUEST_FOR_REFUND_SUCCESSFUL%%') {

          if (this.$route.query.id) {

            let query = { data: null as any };

            this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

            this.parcels = query.data;

          } else {

            let query = await axios.get('api/Parcel/GetParcelsForDashboard');

            this.parcels = query.data;

          }

          this.loading = false;

          this.snackbars.genericInfoText = 'The registration has been successfully cancelled.';

          this.snackbars.genericInfoSnackbar = true;
        }
        else
        {
          this.loading = false;

          this.snackbars.genericErrorText = 'The registration could not be refunded.  Please contact Metro Vancouver for further assistance.';

          this.snackbars.genericErrorSnackbar = true;
        }

      }, 200);

    },

    removeRegistration() {

      this.clearSnackbars();

      this.dialogs.confirmRemoveRegistrationDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Registration/RemoveRegistration?id=' + this.registrationId);

        if (this.$route.query.id) {

          let query = { data: null as any };

          this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

          this.loading = false;

          this.parcels = query.data;

        } else {

          let query = await axios.get('api/Parcel/GetParcelsForDashboard');

          this.loading = false;

          this.parcels = query.data;

        }

        this.snackbars.genericInfoText = 'The registration has been removed.';

        this.snackbars.genericInfoSnackbar = true;

      }, 200);

    },

    confirmPromptAddToCart() {

      this.clearSnackbars();

      this.dialogs.promptAddToCartDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Cart/AddToCart?id=' + this.registrationId);

        if (this.$route.query.id) {

          let query = { data: null as any };

          this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

          this.loading = false;

          this.parcels = query.data;

        } else {

          this.$router.push('/Cart');

        }

        this.snackbars.addedToCartSnackbar = true;

      }, 200);

    },

    async removeParcel() {

      this.clearSnackbars();

      this.dialogs.confirmRemoveParcelDialog = false;

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Parcel/RemoveParcel?id=' + this.parcelId);

        if (this.$route.query.id) {

          this.dialogs.parcelRemovedDialog = true;

        } else {

          let query = await axios.get('api/Parcel/GetParcelsForDashboard');

          this.loading = false;

          this.parcels = query.data;

          this.snackbars.genericInfoText = 'The parcel has been removed.';

          this.snackbars.genericInfoSnackbar = true;

        }

      }, 200);

    },

    async openRegistrationHistory(id: any) {

      this.clearSnackbars();

      this.parcelId = id;

      let info = await axios.get('api/Parcel/GetParcelInfo?id=' + this.parcelId);

      this.parcelInfo = info.data;

      let obj = await axios.get('api/RegistrationHistory/GetRegistrationHistory?parcelId=' + this.parcelId);

      this.registrationHistory = obj.data;

      this.dialogs.registrationHistoryDialog = true;

    },

    async openRegistrationDetails(id: any) {

      this.clearSnackbars();

      let registration = await axios.get('api/Registration/GetRegistrationDetails?id=' + id);

      this.registrationDetails = registration.data;

      if (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Officer') {

        let notes = { data: null as any };

        this.registrationDetails.notes = notes.data.notes;

        this.registrationDetails.notesDateUpdated = notes.data.notesDateUpdated;

        this.registrationDetails.notesLastUpdatedBy = notes.data.notesLastUpdatedBy;

      }

      this.parcelId = registration.data.parcelId;

      this.registrationId = id;

      // close the registration history dialog if necessary
      this.dialogs.registrationHistoryDialog = false;

      this.dialogs.registrationDetailsDialog = true;

    },

    async selectOwner() {

      this.clearSnackbars();

      let obj = await axios.get('api/Owner/GetOwners?parcelId=' + this.parcelId);

      this.newParcel.owners = obj.data;

      this.dialogs.importOwnerDetailsDialog = true;

    },

    async importOwnerDetails(index:number) {

      var owner = this.newParcel.owners[index];

      this.newOperator.company = owner.company;

      this.newOperator.firstName = owner.firstName;

      this.newOperator.lastName = owner.lastName;

      this.newOperator.email = owner.email;

      this.newOperator.countryCode = owner.countryCode;

      this.newOperator.phone = owner.phone;

      this.newOperator.addressLine1 = owner.addressLine1;

      this.newOperator.addressLine2 = owner.addressLine2;

      this.newOperator.city = owner.city;

      this.newOperator.province = owner.province;

      this.newOperator.postalCode = owner.postalCode;

      this.newOperator.preferredMethodOfContact = owner.preferredMethodOfContact;

      this.dialogs.importOwnerDetailsDialog = false;

    },

    confirmPromptAddParcel() {

      this.clearSnackbars();

      this.dialogs.promptAddParcelDialog = false;

      this.dialogs.addParcelDialogMode = 'add';

      this.newParcel.isCertified = false;

      this.$v.newParcel.$reset();

      this.dialogs.addParcelDialog = true;

    },

    cancelRegisterParcel() {

      this.clearSnackbars();

      var hasValues = false;

      if (this.newRegistration.typeOfBurn != '' || this.newRegistration.startDate != '' || this.newRegistration.endDate != '' || this.newRegistration.operators.length >= 1) hasValues = true;

      if (hasValues)
      {
        this.dialogs.confirmCancelRegisterParcelDialog = true;
      }
      else
      {
        this.dialogs.registerParcelDialog = false;
      }

    },

    formatDate (date:any):any {

      if (!date) return null

      const [year, month, day] = date.split('-')

      return `${month}/${day}/${year}`

    },

    parseDate (date:any):any {

      if (!date) return null

      const [month, day, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

    },

    async confirmPromptRegisterParcel() {

      this.clearSnackbars();

      this.dialogs.promptRegisterParcelDialog = false;

      this.$v.newRegistration.$reset();

      this.registrationId = null;

      this.newRegistration.typeOfBurn = '';

      let dateQuery = await axios.get('api/Date/GetDate');

      this.newRegistration.startDate = dateQuery.data;

      this.newRegistration.availableStartDates = this.availableStartDates;

      let obj = await axios.get('api/Registration/GetExpiration?startDate=' + dateQuery.data);

      this.newRegistration.endDate = obj.data;

      this.newRegistration.operators = [];

      this.dialogs.canEditTypeOfBurnOnRegisterParcelDialog = true;

      this.dialogs.canEditStartDateOnRegisterParcelDialog = true;

      this.newRegistration.validateStartDate = true;

      this.dialogs.registerParcelDialog = true;

    },

    async registerParcel(parcelId: any) {

      this.clearSnackbars();

      this.dialogs.promptRegisterParcelDialog = false;

      this.$v.newRegistration.$reset();

      this.parcelId = parcelId;

      this.registrationId = null;

      this.newRegistration.typeOfBurn = '';

      let dateQuery = await axios.get('api/Date/GetDate');

      this.newRegistration.startDate = dateQuery.data;

      this.newRegistration.availableStartDates = this.availableStartDates;

      let obj = await axios.get('api/Registration/GetExpiration?startDate=' + dateQuery.data);

      this.newRegistration.endDate = obj.data;

      this.newRegistration.operators = [];

      this.dialogs.canEditTypeOfBurnOnRegisterParcelDialog = true;

      this.dialogs.canEditStartDateOnRegisterParcelDialog = true;

      this.newRegistration.validateStartDate = true;

      this.dialogs.registerParcelDialog = true;

    },

    async updateParcel(id: any) {

      this.clearSnackbars();

      try {

        this.parcelId = id;

        let parcel = await axios.get('api/Parcel/GetParcel?id=' + id);

        this.newParcel = parcel.data;

        if (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Officer') {

          let notes = { data: null as any };

          this.newParcel.notes = notes.data.notes;

          this.newParcel.notesDateUpdated = notes.data.notesDateUpdated;

          this.newParcel.notesLastUpdatedBy = notes.data.notesLastUpdatedBy;
        }

        if (this.newParcel.hasPayment && this.$store.state.user.role == 'User') {

          this.dialogs.canEditAddress = false;

          this.dialogs.canEditMunicipality = false;

          this.dialogs.canEditOtherLocationDetails = false;

          this.dialogs.canEditPID = false;

          this.dialogs.canEditPostalCode = false;
        }

        this.dialogs.addParcelDialogMode = 'edit';

        this.$v.newParcel.$reset();

        this.dialogs.addParcelDialog = true;

      } catch (error) {

        if (this.$route.path != '/Login') this.$router.push('/Login');

      }

    },

    async updateRegistration(id: any, disableEditTypeOfBurnAndStartDate: boolean) {

      this.clearSnackbars();

      var parcel = await axios.get('api/Registration/GetParcelId?id=' + id);

      this.parcelId = parcel.data;

      this.registrationId = id;

      var query = await axios.get('api/Registration/GetRegistration?id=' + id);

      this.newRegistration = query.data;

      if (this.$store.state.user.role == 'Admin' || this.$store.state.user.role == 'Officer') {

        let notes = { data: null as any };

        this.newRegistration.notes = notes.data.notes;

        this.newRegistration.notesDateUpdated = notes.data.notesDateUpdated;

        this.newRegistration.notesLastUpdatedBy = notes.data.notesLastUpdatedBy;

      }

      this.newRegistration.availableStartDates = this.availableStartDates;

      this.$v.newRegistration.$reset();

      if (disableEditTypeOfBurnAndStartDate) {

        this.dialogs.canEditTypeOfBurnOnRegisterParcelDialog = false;

        this.dialogs.canEditStartDateOnRegisterParcelDialog = false;

        this.newRegistration.validateStartDate = false;

      }
      else
      {
        this.dialogs.canEditTypeOfBurnOnRegisterParcelDialog = true;

        this.dialogs.canEditStartDateOnRegisterParcelDialog = true;

        this.newRegistration.validateStartDate = true;
      }

      this.dialogs.registerParcelDialog = true;

    },

    updateOwner(index: any) {

      this.clearSnackbars();

      this.updateOwnerIndex = index;

      var obj = this.newParcel.owners[index];

      this.newOwner.company = obj.company;

      this.newOwner.firstName = obj.firstName;

      this.newOwner.lastName = obj.lastName;

      this.newOwner.email = obj.email;

      this.newOwner.countryCode = obj.countryCode;

      this.newOwner.phone = obj.phone;

      this.newOwner.addressLine1 = obj.addressLine1;

      this.newOwner.addressLine2 = obj.addressLine2;

      this.newOwner.lastName = obj.lastName;

      this.newOwner.city = obj.city;

      this.newOwner.province = obj.province;

      this.newOwner.postalCode = obj.postalCode;

      this.newOwner.preferredMethodOfContact = obj.preferredMethodOfContact;

      this.newOwner.isPrimary = obj.isPrimary;

      this.newOwner.canEditFirstName = obj.canEditFirstName;

      this.newOwner.canEditLastName = obj.canEditLastName;

      this.dialogs.addOwnerDialogMode = 'edit';

      this.dialogs.addOwnerDialog = true;

    },

    updateOperator(index: any) {

      this.clearSnackbars();

      this.updateOperatorIndex = index;

      var obj = this.newRegistration.operators[index];

      this.newOperator.company = obj.company;

      this.newOperator.firstName = obj.firstName;

      this.newOperator.lastName = obj.lastName;

      this.newOperator.email = obj.email;

      this.newOperator.countryCode = obj.countryCode;

      this.newOperator.phone = obj.phone;

      this.newOperator.addressLine1 = obj.addressLine1;

      this.newOperator.addressLine2 = obj.addressLine2;

      this.newOperator.lastName = obj.lastName;

      this.newOperator.city = obj.city;

      this.newOperator.province = obj.province;

      this.newOperator.postalCode = obj.postalCode;

      this.newOperator.preferredMethodOfContact = obj.preferredMethodOfContact;

      this.dialogs.addOperatorDialogMode = 'edit';

      this.dialogs.addOperatorDialog = true;

    },

    removeOwner() {

      this.clearSnackbars();

      this.dialogs.confirmRemoveOwnerDialog = false;

      if (this.removeOwnerIndex != null) {

        this.newParcel.owners.splice(this.removeOwnerIndex, 1);

        // make sure that the list of owners has at least one primary contact

        var hasPrimaryOwner = false;

        for (var j = 0; j < this.newParcel.owners.length; j++)
        {
          if (this.newParcel.owners[j].isPrimary) hasPrimaryOwner = true;
        }

        if (!hasPrimaryOwner) {

          // this is no primary owner

          if (this.newParcel.owners.length > 0) {

            this.newParcel.owners[0].isPrimary = true;

          }

        }

      }

    },

    confirmRemoveParcel(id: any) {

      this.clearSnackbars();

      this.parcelId = id;

      this.dialogs.confirmRemoveParcelDialog = true;

    },

    confirmRemoveOwner(index: any) {

      this.clearSnackbars();

      this.removeOwnerIndex = index;

      this.dialogs.confirmRemoveOwnerDialog = true;

    },

    removeOperator() {

      this.dialogs.confirmRemoveOperatorDialog = false;

      if (this.removeOperatorIndex != null)
      {
        this.newRegistration.operators.splice(this.removeOperatorIndex, 1);
      }

    },

    confirmRemoveOperator(index: any) {

      this.clearSnackbars();

      this.removeOperatorIndex = index;

      this.dialogs.confirmRemoveOperatorDialog = true;

    },

    confirmCancelNewOwner() {

      this.clearSnackbars();

      this.dialogs.confirmCancelNewOwnerDialog = false;

      this.dialogs.addOwnerDialog = false;

    },

    confirmCancelNewOperator() {

      this.clearSnackbars();

      this.dialogs.confirmCancelNewOperatorDialog = false;

      this.dialogs.addOperatorDialog = false;

    },

    confirmCancelNewParcel() {

      this.clearSnackbars();

      this.dialogs.confirmCancelNewParcelDialog = false;

      this.dialogs.addParcelDialog = false;

    },

    confirmCancelRegisterParcel() {

      this.clearSnackbars();

      this.dialogs.confirmCancelRegisterParcelDialog = false;

      this.dialogs.registerParcelDialog = false;

    },

    async addOwner() {

      this.clearSnackbars();

      // validate against adding more than 6 owners
      if (this.newParcel.owners.length == 6) {

        this.snackbars.genericErrorText = 'You cannot add more than 6 owners to a parcel.';

        this.snackbars.genericErrorSnackbar = true;

        return;
      }

      this.$v.newOwner.$reset();

      this.newOwner.company = '';

      this.newOwner.firstName = '';

      this.newOwner.lastName = '';

      this.newOwner.email = '';

      this.newOwner.countryCode = '1CA';

      this.newOwner.phone = '';

      this.newOwner.addressLine1 = '';

      this.newOwner.addressLine2 = '';

      this.newOwner.city = '';

      this.newOwner.province = '';

      this.newOwner.postalCode = '';

      this.newOwner.preferredMethodOfContact = '';

      this.newOwner.isPrimary = false;

      this.newOwner.canEditFirstName = true;

      this.newOwner.canEditLastName = true;

      this.updateOwnerIndex = null;

      this.dialogs.addOwnerDialogMode = 'add';

      this.dialogs.addOwnerDialog = true;

    },

    addOperator(source:any) {

      this.clearSnackbars();

      // validate against adding more than 10 operators

      if (this.newRegistration.operators.length == 10) {

        this.snackbars.genericErrorText = 'You cannot add more than 10 operators to a registration.';

        this.snackbars.genericErrorSnackbar = true;

        return;
      }

      this.$v.newParcel.$reset();

      this.$v.newOperator.$reset();

      this.newOperator.company = '';

      this.newOperator.firstName = '';

      this.newOperator.lastName = '';

      this.newOperator.email = '';

      this.newOperator.countryCode = '1CA';

      this.newOperator.phone = '';

      this.newOperator.addressLine1 = '';

      this.newOperator.addressLine2 = '';

      this.newOperator.city = '';

      this.newOperator.province = '';

      this.newOperator.postalCode = '';

      this.newOperator.preferredMethodOfContact = '';

      this.updateOperatorIndex = null;

      this.dialogs.addOperatorDialogMode = 'add';

      this.dialogs.addOperatorDialog = true;

    },

    addParcel() {

      this.clearSnackbars();

      this.parcelId = null;

      this.newParcel.id = null;

      this.newParcel.address = '';

      this.newParcel.municipality = '';

      this.newParcel.postalCode = '';

      this.newParcel.otherLocationDetails = '';

      this.newParcel.pid = '';

      this.newParcel.owners = [];

      this.dialogs.addParcelDialogMode = 'add';

      this.dialogs.canEditAddress = true;

      this.dialogs.canEditMunicipality = true;

      this.dialogs.canEditOtherLocationDetails = true;

      this.dialogs.canEditPID = true;

      this.dialogs.canEditPostalCode = true;

      this.newParcel.isCertified = false;

      this.$v.newParcel.$reset();

      this.dialogs.addParcelDialog = true;

    },

    async addToCart(id: number) {

      this.clearSnackbars();

      this.loading = true;

      setTimeout(async () => {

        let obj = await axios.get('api/Cart/AddToCart?id=' + id);

        if (this.$route.query.id) {

          let query = { data: null as any };

          this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

          this.loading = false;

          this.parcels = query.data;

        } else {

          let query = await axios.get('api/Parcel/GetParcelsForDashboard');

          this.loading = false;

          this.parcels = query.data;

        }

        this.snackbars.addedToCartSnackbar = true;

      }, 200);

    },

    async submitNewParcel() {

      this.clearSnackbars();

      this.$v.newParcel.$touch();

      if (this.$v.newParcel.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        // the form is valid

        this.dialogs.addParcelDialog = false;

        this.loading = true;

        setTimeout(async () => {

          // trim parcel before posting

          if(this.newParcel.address) this.newParcel.address = this.newParcel.address.trim();

          if (this.newParcel.municipality) this.newParcel.municipality = this.newParcel.municipality.trim();

          if (this.newParcel.otherLocationDetails) this.newParcel.otherLocationDetails = this.newParcel.otherLocationDetails.trim();

          if (this.newParcel.pid) this.newParcel.pid = this.newParcel.pid.trim();

          var msg = '';

          if (this.newParcel.id)
          {
            // we are updating the parcel

            try {

              let obj = await axios.post('api/Parcel/UpdateParcel', this.newParcel);

              msg = 'The parcel has been updated successfully.';

              if (this.$route.query.id) {

                let query = { data: null as any };

                this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

                this.loading = false;

                this.parcels = query.data;

              } else {

                let query = await axios.get('api/Parcel/GetParcelsForDashboard');

                this.loading = false;

                this.parcels = query.data;

              }

              this.snackbars.genericInfoText = msg;

              this.snackbars.genericInfoSnackbar = true;

            }
            catch (error:any)
            {
              // an exception has been thrown

              if (error.response && error.response.status == 401) {

                // the exception was unauhorized, redirect to login screen

                if (this.$route.path != '/Login') this.$router.push('/Login');

              }
              else {

                this.clearSnackbars();

                this.snackbars.genericErrorText = 'There was an issue contacting the server.';

                this.snackbars.genericErrorSnackbar = true;

              }

            }

          }
          else {

            try {

              // this is a new parcel

              let obj = await axios.post('api/Parcel/CreateParcel', this.newParcel);

              if (obj.data == '%%FAILED%%') {

                this.loading = false;

                this.snackbars.genericErrorText = 'There was an error creating your parcel.  Please try again.';

                this.snackbars.genericErrorSnackbar = true;

                this.dialogs.addParcelDialog = true;

                return;

              }

              this.parcelId = parseInt(obj.data.match(/-(\d+)/)[1]);

              if (this.$route.query.id) {

                let query = { data: null as any };

                this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

                this.loading = false;

                this.parcels = query.data;

              } else {

                let query = await axios.get('api/Parcel/GetParcelsForDashboard');

                this.loading = false;

                this.parcels = query.data;

              }

              this.dialogs.promptRegisterParcelDialog = true;

            } catch (error) {

              if (this.$route.path != '/Login') this.$router.push('/Login');

            }

          }

        }, 200);

      }

    },

    submitNewOwner() {

      this.clearSnackbars();

      this.$v.newOwner.$touch();

      if (this.$v.newOwner && this.$v.newOwner.$error) {

        this.snackbars.errorSnackbar = true;

      }
      else
      {
        // the form is valid

        if (this.newOwner.isPrimary)
        {
          // this owner is the primary owner (set all the existing owners to isPrimary is false)

          for (var i = 0; i < this.newParcel.owners.length; i++) {

            this.newParcel.owners[i].isPrimary = false;

          }

        }

        if (this.updateOwnerIndex == null) {

          // adding a new owner

          var obj = {

            id: null,

            company: this.newOwner.company ? this.newOwner.company.trim() : this.newOwner.company,

            firstName: this.newOwner.firstName ? this.newOwner.firstName.trim() : this.newOwner.firstName,

            lastName: this.newOwner.lastName ? this.newOwner.lastName.trim() : this.newOwner.lastName,

            email: this.newOwner.email ? this.newOwner.email.trim() : this.newOwner.email,

            countryCode: this.newOwner.countryCode,

            phone: this.newOwner.phone ? this.newOwner.phone.trim() : this.newOwner.phone,

            addressLine1: this.newOwner.addressLine1 ? this.newOwner.addressLine1.trim() : this.newOwner.addressLine1,

            addressLine2: this.newOwner.addressLine2 ? this.newOwner.addressLine2.trim() : this.newOwner.addressLine2,

            city: this.newOwner.city ? this.newOwner.city.trim() : this.newOwner.city,

            province: this.newOwner.province,

            postalCode: this.newOwner.postalCode ? this.newOwner.postalCode.trim() : this.newOwner.postalCode,

            preferredMethodOfContact: this.newOwner.preferredMethodOfContact,

            isPrimary: this.newOwner.isPrimary,

            canEditFirstName:  this.newOwner.canEditFirstName,

            canEditLastName: this.newOwner.canEditLastName

          }

          this.newParcel.owners.push(obj);

        }
        else
        {
          // updating an existing owner

          this.newParcel.owners[this.updateOwnerIndex].company = this.newOwner.company;

          this.newParcel.owners[this.updateOwnerIndex].firstName = this.newOwner.firstName;

          this.newParcel.owners[this.updateOwnerIndex].lastName = this.newOwner.lastName;

          this.newParcel.owners[this.updateOwnerIndex].email = this.newOwner.email;

          this.newParcel.owners[this.updateOwnerIndex].countryCode = this.newOwner.countryCode;

          this.newParcel.owners[this.updateOwnerIndex].phone = this.newOwner.phone;

          this.newParcel.owners[this.updateOwnerIndex].addressLine1 = this.newOwner.addressLine1;

          this.newParcel.owners[this.updateOwnerIndex].addressLine2 = this.newOwner.addressLine2;

          this.newParcel.owners[this.updateOwnerIndex].city = this.newOwner.city;

          this.newParcel.owners[this.updateOwnerIndex].province = this.newOwner.province;

          this.newParcel.owners[this.updateOwnerIndex].postalCode = this.newOwner.postalCode;

          this.newParcel.owners[this.updateOwnerIndex].preferredMethodOfContact = this.newOwner.preferredMethodOfContact;

          this.newParcel.owners[this.updateOwnerIndex].isPrimary = this.newOwner.isPrimary;
        }

        // make sure that the list of owners has at least one primary contact

        var hasPrimaryOwner = false;

        for (var j = 0; j < this.newParcel.owners.length; j++)
        {
          if (this.newParcel.owners[j].isPrimary) hasPrimaryOwner = true;
        }

        if (!hasPrimaryOwner) {

          // this is no primary owner

          if (this.newParcel.owners.length > 0) {

            this.newParcel.owners[0].isPrimary = true;

          }

        }

        this.dialogs.addOwnerDialog = false;
      }

    },

    submitNewOperator() {

      this.clearSnackbars();

      this.$v.newOperator.$touch();

      if (this.$v.newOperator && this.$v.newOperator.$error) {

        this.snackbars.errorSnackbar = true;

        return;

      }

      if (this.dialogs.addOperatorDialogMode == 'add') {

        var obj = {

          company: this.newOperator.company ? this.newOperator.company.trim() : this.newOperator.company,

          firstName: this.newOperator.firstName ? this.newOperator.firstName.trim() : this.newOperator.firstName,

          lastName: this.newOperator.lastName ? this.newOperator.lastName.trim() : this.newOperator.lastName,

          email: this.newOperator.email ? this.newOperator.email.trim() : this.newOperator.email,

          countryCode: this.newOperator.countryCode,

          phone: this.newOperator.phone ? this.newOperator.phone.trim() : this.newOperator.phone,

          addressLine1: this.newOperator.addressLine1 ? this.newOperator.addressLine1.trim() : this.newOperator.addressLine1,

          addressLine2: this.newOperator.addressLine2 ? this.newOperator.addressLine2.trim() : this.newOperator.addressLine2,

          city: this.newOperator.city ? this.newOperator.city.trim() : this.newOperator.city,

          province: this.newOperator.province,

          postalCode: this.newOperator.postalCode ? this.newOperator.postalCode.trim() : this.newOperator.postalCode,

          preferredMethodOfContact: this.newOperator.preferredMethodOfContact

        }

        this.newRegistration.operators.push(obj);

      }
      else
      {
        if (this.updateOperatorIndex != null) {

          this.newRegistration.operators[this.updateOperatorIndex].company = this.newOperator.company;

          this.newRegistration.operators[this.updateOperatorIndex].firstName = this.newOperator.firstName;

          this.newRegistration.operators[this.updateOperatorIndex].lastName = this.newOperator.lastName;

          this.newRegistration.operators[this.updateOperatorIndex].email = this.newOperator.email;

          this.newRegistration.operators[this.updateOperatorIndex].countryCode = this.newOperator.countryCode;

          this.newRegistration.operators[this.updateOperatorIndex].phone = this.newOperator.phone;

          this.newRegistration.operators[this.updateOperatorIndex].addressLine1 = this.newOperator.addressLine1;

          this.newRegistration.operators[this.updateOperatorIndex].addressLine2 = this.newOperator.addressLine2;

          this.newRegistration.operators[this.updateOperatorIndex].city = this.newOperator.city;

          this.newRegistration.operators[this.updateOperatorIndex].province = this.newOperator.province;

          this.newRegistration.operators[this.updateOperatorIndex].postalCode = this.newOperator.postalCode;

          this.newRegistration.operators[this.updateOperatorIndex].preferredMethodOfContact = this.newOperator.preferredMethodOfContact;

        }

      }

      this.dialogs.addOperatorDialog = false;

    },

    async submitNewRegistration() {

      this.clearSnackbars();

      this.$v.newRegistration.$touch();

      if (this.$v.newRegistration.$error) {

        this.snackbars.errorSnackbar = true;

      } else {

        // the form is valid

        // we need to do one extra check (at least one operator must be added)

        if (this.newRegistration.operators.length == 0){

          // there are no operators

          this.snackbars.genericErrorText = 'You must add at least one operator.';

          this.snackbars.genericErrorSnackbar = true;

          return;

        }

        this.dialogs.registerParcelDialog = false;

        this.newRegistration.parcelId = this.parcelId;

        this.loading = true;

        setTimeout(async () => {

          if (this.registrationId == null) {

            // we are creating a new registration

            let obj = await axios.post('api/Registration/CreateRegistration', this.newRegistration);

            if (obj.data == '%%FAILED%%') {

              this.loading = false;

              this.snackbars.genericErrorText = 'There was an error adding the registration.  Please try again.';

              this.snackbars.genericErrorSnackbar = true;

              this.dialogs.registerParcelDialog = true;

              return;

            }

            if (obj.data == '%%REGISTRATION_COLLISION%%')
            {
              this.loading = false;

              this.snackbars.genericErrorText = 'The registration could not be created because it overlaps with an existing registration. Please try again with different dates.';

              this.snackbars.genericErrorSnackbar = true;

              this.dialogs.registerParcelDialog = true;

              return;
            }

            var id = obj.data.match(/\d+/)[0];

            this.registrationId = id;

            if (this.$route.query.id) {

              let query = { data: null as any };

              this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

              this.loading = false;

              this.parcels = query.data;

            } else {

              let query = await axios.get('api/Parcel/GetParcelsForDashboard');

              this.loading = false;

              this.parcels = query.data;

            }

            this.dialogs.promptAddToCartDialog = true;

          }
          else {

            // we are updating an existing registration

            this.newRegistration.id = this.registrationId;

            let obj = await axios.post('api/Registration/UpdateRegistration', this.newRegistration);

            if (obj.data == '%%REGISTRATION_COLLISION%%')
            {
              this.loading = false;

              this.snackbars.genericErrorText = 'The registration could not be created because it overlaps with an existing registration. Please try again with different dates.';

              this.snackbars.genericErrorSnackbar = true;

              this.dialogs.registerParcelDialog = true;

              return;
            }

            if (this.$route.query.id) {

              let query = { data: null as any };

              this.formInfo = "You are viewing/editing account information for <strong>" + query.data[0].email + "</strong>.";

              this.loading = false;

              this.parcels = query.data;

            } else {

              let query = await axios.get('api/Parcel/GetParcelsForDashboard');

              this.loading = false;

              this.parcels = query.data;

            }

            this.snackbars.genericInfoText = 'The registration has been updated.';

            this.snackbars.genericInfoSnackbar = true;

          }

        }, 200);

      }

    },

    cancelAddOwner() {

      this.clearSnackbars();

      var hasValues = false;

      if (this.newOwner.company || this.newOwner.firstName || this.newOwner.lastName || this.newOwner.email || this.newOwner.phone || this.newOwner.addressLine1 || this.newOwner.addressLine2 || this.newOwner.city || this.newOwner.province || this.newOwner.postalCode) hasValues = true;

      if (hasValues) {

        this.dialogs.confirmCancelNewOwnerDialog = true;

      }
      else
      {
        this.dialogs.addOwnerDialog = false;
      }

    },

    cancelAddOperator() {

      this.clearSnackbars();

      var hasValues = false;

      if (this.newOperator.company || this.newOperator.firstName || this.newOperator.lastName || this.newOperator.email || this.newOperator.phone || this.newOperator.addressLine1 || this.newOperator.addressLine2 || this.newOperator.city || this.newOperator.province || this.newOperator.postalCode) hasValues = true;

      if (hasValues) {

        this.dialogs.confirmCancelNewOperatorDialog = true;

      }
      else
      {
        this.dialogs.addOperatorDialog = false;
      }

    },

    cancelAddParcel() {

      this.clearSnackbars();

      var hasValues = false;

      if (this.newParcel.address || this.newParcel.municipality || this.newParcel.postalCode || this.newParcel.otherLocationDetails || this.newParcel.pid || this.newParcel.owners.length > 1) hasValues = true;

      if (hasValues)
      {
        this.dialogs.confirmCancelNewParcelDialog = true;
      }
      else
      {
        this.dialogs.addParcelDialog = false;
      }
    },

    clearSnackbars(){

      this.snackbars.errorSnackbar = false;

      this.snackbars.genericInfoSnackbar = false;

      this.snackbars.genericErrorSnackbar = false;

      this.snackbars.addedToCartSnackbar = false;

    }

  },

  watch: {

    manualPaymentDatePicker (val) {

      this.newManualPayment.date = this.formatDate(this.manualPaymentDatePicker)

    },

    manualRefundDatePicker (val) {

      this.newManualRefund.date = this.formatDate(this.manualRefundDatePicker)

    },

    'newParcel.pid': function (value: string) {

      if (/^\d{9}$/.test(value)) {

        this.newParcel.pid = value.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3');
      }

    },

    'newParcel.postalCode': function (value: string) {

      const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/;

      if (postalCodeRegex.test(value)) {

        const formattedPostalCode = value.toUpperCase().replace(/^(.{3})(.{3})$/, '$1 $2');

        this.newParcel.postalCode = formattedPostalCode;

      }

    },

    'newOwner.postalCode': function (value) {

      const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

      if (postalCodeRegex.test(value)) {

        const formattedPostalCode = value.toUpperCase().replace(/^(.{3})(.{3})$/, '$1 $2');

        this.newOwner.postalCode = formattedPostalCode;

      }

    },

    'newOperator.postalCode': function (value) {

      const postalCodeRegex = /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/;

      if (postalCodeRegex.test(value)) {

        const formattedPostalCode = value.toUpperCase().replace(/^(.{3})(.{3})$/, '$1 $2');

        this.newOperator.postalCode = formattedPostalCode;

      }

    },

    'newOwner.phone': function (value: string) {

      if (/^\d{10}$/.test(value)) {

        this.newOwner.phone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);

      }

    },

    'newOperator.phone': function (value: string) {

      if (/^\d{10}$/.test(value)) {

        this.newOperator.phone = value.slice(0, 3) + '-' + value.slice(3, 6) + '-' + value.slice(6);

      }

    },

    'newRegistration.startDate': async function (val) {

      if (val) {

        let obj = await axios.get('api/Registration/GetExpiration?startDate=' + val);

        if (obj.data != '%%FAILED%%') {

          this.newRegistration.endDate = obj.data;

        }
        else
        {
          this.newRegistration.endDate = '';
        }

      }
    },

    date (val) {

      this.newRegistration.startDate = this.formatDate(this.date)

    },

    async searchOwner(val) {

      if (val == null || val == '')
      {
        // the search query is blank: clear the entries

        this.newOwner.addresses = [];

        return;
      }

      if (this.newOwner.isLoading) return;

      this.newOwner.isLoading = true

      var url = 'https://geocoder.api.gov.bc.ca/addresses.json?addressString=' + val + '&locationDescriptor=any&maxResults=9999&interpolation=adaptive&echo=true&brief=false&autoComplete=true&setBack=0&outputSRS=4326&minScore=1&provinceCode=BC';

      let obj = await axios.get(url);

      this.newOwner.addresses = [];

      for (var i = 0; i < obj.data.features.length; i++)
      {
        this.newOwner.addresses.push(obj.data.features[i].properties.fullAddress);
      }

      this.newOwner.isLoading = false;

    },

    async searchOperator(val) {

      if (val == null || val == '')
      {
        // the search query is blank: clear the entries

        this.newOperator.addresses = [];

        return;
      }

      if (this.newOperator.isLoading) return;

      this.newOperator.isLoading = true

      var url = 'https://geocoder.api.gov.bc.ca/addresses.json?addressString=' + val + '&locationDescriptor=any&maxResults=9999&interpolation=adaptive&echo=true&brief=false&autoComplete=true&setBack=0&outputSRS=4326&minScore=1&provinceCode=BC';

      let obj = await axios.get(url);

      this.newOperator.addresses = [];

      for (var i = 0; i < obj.data.features.length; i++)
      {
        this.newOperator.addresses.push(obj.data.features[i].properties.fullAddress);
      }

      this.newOperator.isLoading = false;

    },

    'newOwner.addressLookup': function (val) {

      if (val) {

        var query = val.split(',');

        this.newOwner.addressLine1 = query[0].trim();

        this.newOwner.city = query[1].trim();

        this.newOwner.province = 'BC';

        this.newOwner.addresses = [];

      }

    },

    'newOperator.addressLookup': function (val) {

      if (val) {

        var query = val.split(',');

        this.newOperator.addressLine1 = query[0].trim();

        this.newOperator.city = query[1].trim();

        this.newOperator.province = 'BC';

        this.newOperator.addresses = [];

      }

    }
  }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

p, div, label, a {

  font-family: Nunito !important;

  font-size: 19px !important;

}

.v-messages__message {

  font-size: 14px !important;

}

th > .v-icon {

  color: white !important;

}

hr {

  height: 1px;

  background-color: lightgray;

  border: none;

}

#endDate {

  background-color: whitesmoke

}

#manualPaymentAmount {

  background-color: whitesmoke

}

</style>
